// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:41:27.914Z
// Property: 1801 Metrowest (ID: 5690533913559040)
// Collections: 20 amenities, 5 floorplans (live), 32 photos, 75 POIs, 2 reviews, 3 virtual tours, 6 office hours, 25 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5690533913559040",
  "property_external_id": "4767207",
  "property_zillow_url": "https://www.zillow.com/apartments/orlando-fl/1801-metrowest/5XhxtS/",
  "property_apartments_url": "https://www.apartments.com/1801-metrowest-orlando-fl/53dh5wn",
  "property_google_business_url": "https://www.google.com/maps/place/1801+MetroWest/@28.5203375,-81.4576124,15z/data=!4m5!3m4!1s0x0:0x1d10faa628ad741e!8m2!3d28.5203896!4d-81.4576703",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443957572",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "1801-metrowest",
  "property_name": "1801 Metrowest",
  "property_website_url": "https://www.1801metrowest.com/",
  "property_domain": "https://www.1801metrowest.com/",
  "property_address": "1801 S Kirkman Rd",
  "property_full_address": "1801 S Kirkman Rd, Orlando, FL 32811",
  "property_address_1": "1801 S Kirkman Rd",
  "property_address_2": null,
  "property_address_city": "Orlando",
  "property_address_state": "FL",
  "property_address_zip_full": "32811-2328",
  "property_address_zip": "32811",
  "property_address_country": "US",
  "property_address_county": "Orange County",
  "property_neighborhood_address": "Southwest Orlando",
  "property_address_latitude": "28.5199659",
  "property_address_longitude": "-81.4560506",
  "property_email": "metrowest@alapts.com",
  "property_phone": "(407) 293-3355",
  "property_call_tracking_phone": "407-904-6785",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Live connected in Southwest Orlando.</strong> Explore upgraded one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> with modern kitchens, screened outdoor space, and everyday conveniences designed for easy living—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see 1801 MetroWest in person.</p>",
  "property_long_description": "<p><strong>Live connected in Southwest Orlando.</strong> At 1801 MetroWest, you’re positioned on South Kirkman Road near Valencia College, The Mall at Millenia, I-4, SR 408, and SR 435—putting shopping, dining, major healthcare employers, Universal-area entertainment, and downtown Orlando within easy reach. Around MetroWest, lakes, everyday conveniences, and local favorites like Teak Neighborhood Grill give the area a practical, lively rhythm, while Bill Frederick Park at Turkey Lake adds 183 acres of trails, boating, disc golf, and waterfront space nearby.</p><p>Inside the community, choose upgraded one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> with modern chef’s kitchens, stainless-steel appliances, tile backsplashes, white cabinetry, hard-surface flooring, walk-in closets, screened outdoor space, and select loft-style layouts, vaulted ceilings, and wood-burning fireplaces. Your day-to-day is supported by <a href=\"/amenities\">amenities</a> such as a resort-style pool, renovated clubhouse, 24-hour fitness and wellness center, spin room, coffee bar, business center, package lockers, outdoor grilling lounge, online resident services, and a dog park.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-c0c1-71c8-8bca-9655fcabcfae.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
    "public_id": "019e8973-c0c1-71c8-8bca-9655fcabcfae",
    "storage_key": "property/5690533913559040/019e8973-c0c1-71c8-8bca-9655fcabcfae.webp",
    "width": 2690,
    "height": 1794
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "300",
  "property_year_built": "1990",
  "property_year_renovated": "2021",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.33333333333334",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "We have a one-time pet fee of $400 per pet, and monthly pet rent of $30 per pet. ",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8627640.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://1801metrowest.loftliving.com/login",
  "property_apply_now_url": "https://8627640.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019d02f2-7924-77ab-87c0-1bfb0c3efa9e.webp",
  "property_primary_logo_media": {
    "alt_text": "MetroWest Premier Apartments logo",
    "public_id": "019d02f2-7924-77ab-87c0-1bfb0c3efa9e",
    "storage_key": "property/5690533913559040/019d02f2-7924-77ab-87c0-1bfb0c3efa9e.webp",
    "width": 1838,
    "height": 511
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019d02f2-87d5-739b-832c-29122ebc065b.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo.",
    "public_id": "019d02f2-87d5-739b-832c-29122ebc065b",
    "storage_key": "property/5690533913559040/019d02f2-87d5-739b-832c-29122ebc065b.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019df5ad-9db9-76df-bbb9-56de3cf356bf.webp",
  "property_icon_media": {
    "alt_text": "1801 MW logo",
    "public_id": "019df5ad-9db9-76df-bbb9-56de3cf356bf",
    "storage_key": "property/5690533913559040/019df5ad-9db9-76df-bbb9-56de3cf356bf.webp",
    "width": 702,
    "height": 702
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019df5ad-9db9-76df-bbb9-56de3cf356bf.webp",
  "property_fav_icon_media": {
    "alt_text": "1801 MW logo",
    "public_id": "019df5ad-9db9-76df-bbb9-56de3cf356bf",
    "storage_key": "property/5690533913559040/019df5ad-9db9-76df-bbb9-56de3cf356bf.webp",
    "width": 702,
    "height": 702
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019d02f0-86dc-73dc-b2f2-f4a2df62360d.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Metrowest Premier Apartments logo",
    "public_id": "019d02f0-86dc-73dc-b2f2-f4a2df62360d",
    "storage_key": "property/5690533913559040/019d02f0-86dc-73dc-b2f2-f4a2df62360d.webp",
    "width": 1920,
    "height": 533
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019d02f2-7924-77ab-87c0-1bfb0c3efa9e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "MetroWest Premier Apartments logo",
    "public_id": "019d02f2-7924-77ab-87c0-1bfb0c3efa9e",
    "storage_key": "property/5690533913559040/019d02f2-7924-77ab-87c0-1bfb0c3efa9e.webp",
    "width": 1838,
    "height": 511
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#003b70",
  "property_secondary_color": "#c3cf21",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#cccccc",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "723 - 1015",
  "property_sqft_min": "723",
  "property_sqft_max": "1015",
  "property_price_range": "1382.83 - 1607.16",
  "property_price_min": "1382.83",
  "property_price_max": "1607.16",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/1801MetroWest",
  "property_instagram_url": "https://www.instagram.com/1801MetroWest",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJX79Kuxd554gRHnStKKb6EB0",
  "property_youtube_url": "https://www.youtube.com/@1801MetroWestApartments",
  "property_yelp_url": "https://m.yelp.ca/search?find_desc=Real+Estate&find_near=1801-metrowest-orlando",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 1801 Metrowest",
  "property_home_romance_title": "Embrace the Joy of Your New Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Work out, wind down, and handle the day with ease.</strong> 1801 MetroWest brings together a 24-hour fitness and wellness center, spin room, resort-style pool, outdoor grilling lounge, renovated clubhouse, coffee bar, business center, and package lockers. Inside, upgraded Southwest Orlando apartments feature modern kitchens, stainless-steel appliances, tile backsplashes, white cabinetry, hard-surface flooring, and walk-in closets, with select homes offering screened outdoor space, vaulted ceilings, pool views, or wood-burning fireplaces.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to flex.</strong> Explore one- and two-bedroom apartments at 1801 MetroWest, with select upgraded interiors featuring stainless-steel appliances, white cabinetry, tile backsplashes, hard-surface flooring, and walk-in closets. Some homes add screened outdoor space, pool views, loft-style character, tall ceilings, or a wood-burning fireplace—giving each floor plan its own standout style.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture 1801 MetroWest in full color.</strong> Preview palm-lined lawns, shaded walkways, blue poolside seating, and an outdoor grilling area made for easy afternoons. Inside, look for bright living rooms with hard-surface flooring, stainless-steel appliances, tile backsplashes, generous windows, and clean walk-in closet space—plus community scenes from the resident lounge, coffee bar, fitness areas, and package lockers.</p>",
  "property_home_neighborhood_blurb": "<p><strong>MetroWest convenience, Orlando energy.</strong> From 1801 MetroWest, South Kirkman Road puts daily essentials, MetroWest Village, Oodle Ramen, Volcano Hot Pot &amp; BBQ, and casual coffee stops within easy reach. Bigger plans are close, too, with Conroy Road shopping, The Mall at Millenia, and the Universal-area entertainment corridor nearby. For fresh air, Ivey Lane Park and Bill Frederick Park at Turkey Lake bring green space, trails, waterfront views, fishing, and disc golf into the mix.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents keep calling out the easy experience.</strong> Reviews for 1801 Metrowest highlight a smooth, transparent rental process, responsive office support, and prompt maintenance handled with courtesy and care. You’ll also find mentions of clean, well-kept surroundings and an attentive team that helps daily life run more smoothly. Read more resident reviews to see what stands out at 1801 Metrowest.</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the neighborhood, then make the day your own.</strong> From 1801 MetroWest, South Kirkman Road keeps everyday stops close—MetroWest Village for quick errands, local flavor from Oodle Ramen to Volcano Hot Pot &amp; BBQ, and coffee or casual bites within an easy drive. When plans get bigger, you’re positioned near Conroy Road shopping, The Mall at Millenia, and the Universal-area entertainment corridor without losing the laid-back rhythm of Southwest Orlando.</p><p>For fresh air, nearby parks add balance: Ivey Lane Park is close for a simple outdoor reset, while Bill Frederick Park at Turkey Lake brings trails, waterfront views, fishing, and disc golf into your weekend rotation. LYNX Link 21 along the Kirkman corridor adds another way to connect. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location feels in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep pace with your day.</strong> At 1801 MetroWest, you can move from a workout in the 24-hour fitness and wellness center to a focused stretch in the spin room, then reset by the resort-style pool or outdoor grilling lounge. The renovated clubhouse, coffee bar, business center, package lockers, online resident services, and American Landmark 360 program add practical support when your schedule is full.</p><p>Inside your Southwest Orlando apartment, upgraded details make the everyday feel more polished: modern kitchens with stainless-steel appliances, tile backsplashes, white cabinetry, hard-surface flooring, and walk-in closets. Select homes add screened outdoor space, loft-style character, vaulted ceilings, pool views, or a wood-burning fireplace. See the spaces in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience them in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to apply?</strong> Start your online application for 1801 MetroWest and move closer to upgraded one- and two-bedroom floor plans with modern kitchens, hard-surface flooring, walk-in closets, and screened outdoor space—plus everyday access to a connected Southwest Orlando location.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the leasing team at 1801 MetroWest for help finding your way, exploring upgraded one- and two-bedroom layouts, or learning more about this connected Southwest Orlando community.</p>",
  "property_faqs_blurb": "<p><strong>Questions about 1801 MetroWest?</strong> Start here for quick answers about the community, leasing, apartment features, and everyday living in Southwest Orlando. If you don’t see what you need, the leasing team is happy to help you find the right next step.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that fits your day.</strong> At 1801 MetroWest, one- and two-bedroom apartments give you room to define each space your way, from an easy-to-maintain one-bedroom to a two-bedroom design with added flexibility.</p><p>Inside, select upgraded finishes bring a polished feel to daily routines: modern kitchens with stainless-steel appliances, white cabinetry, tile backsplashes, and hard-surface flooring, plus walk-in closets for practical storage. Some homes add screened outdoor space, pool views, loft-style character, tall ceilings, or a wood-burning fireplace for an extra layer of style. Browse the available floor plans, compare current pricing and availability, and find the Orlando apartment that feels like your next move.</p>",
  "property_gallery_blurb": "<p><strong>Let the photos set the pace.</strong> Browse 1801 MetroWest through scenes that feel easy to picture: palm-lined lawns, shaded walkways, blue poolside chairs, and an outdoor grilling area ready for an unhurried afternoon.</p><p>Inside, the gallery brings you closer to the finishes that shape each home—bright living rooms with hard-surface flooring, kitchens with stainless-steel appliances and tile backsplashes, bedrooms with generous windows, and walk-in closets that keep the look clean. You’ll also catch the energy of shared spaces, from the high-ceiling resident lounge and coffee bar to the fitness areas and package lockers. Like what you see? Compare <a href=\"/floor-plans\">available floor plans</a>, explore <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see 1801 MetroWest in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore 1801 MetroWest on the map.</strong><br>See available one- and two-bedroom apartments, then zoom out to discover the Southwest Orlando setting near South Kirkman Road, MetroWest conveniences, lakes, parks, dining, shopping, and easy connections across Orlando.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living should feel easy.</strong> At 1801 MetroWest, your cat or dog has room to settle in, stretch out, and make the most of apartment life in Orlando. With up to two pets welcome per home and no weight limit, you can focus on the routines that matter: morning walks, quick breaks at the on-site dog park, and evenings back in a comfortable home with practical finishes like hard floors and available outdoor space.</p><p>When you want a change of scenery, the surrounding area keeps pet essentials close, from everyday supplies to nearby veterinary care along Kirkman Road. Explore the <a href=\"/amenities\">pet-friendly community features</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how 1801 MetroWest fits life with your favorite companion.</p>",
  "property_referafriend_blurb": "<p><strong>Share life at 1801 MetroWest.</strong> From upgraded one- and two-bedroom layouts with modern kitchens and screened outdoor space to connected Southwest Orlando living and everyday community conveniences, there’s plenty to recommend. Invite a friend to discover it here—just send their details through the referral form.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at 1801 MetroWest.</strong><br>Use online resident services to pay rent, submit maintenance requests, and manage your account—all in one convenient place, with everyday support connected to the community you call home.</p>",
  "property_reviews_blurb": "<p><strong>Real experiences, in residents’ own words.</strong> Reviews for 1801 Metrowest point to a team that makes the day-to-day feel easier—from a rental process described as “smooth, transparent, and very accessible” to office support that residents call helpful, responsive, and caring.</p><p>You’ll also see praise for prompt maintenance service, including courteous, efficient help with service requests, along with comments about clean, well-maintained surroundings and a strong sense of attentiveness throughout the community. Read the reviews below to hear directly from residents about life at 1801 Metrowest.</p>",
  "property_created_at": "1743797426055",
  "property_scheduletour_blurb": "<p><strong>See 1801 MetroWest up close.</strong> Tour upgraded one- and two-bedroom layouts with chef’s kitchens, stainless-steel appliances, hard-surface flooring, walk-in closets, and screened outdoor space—then explore community spaces built for easy everyday living. Schedule your visit and picture life connected in Southwest Orlando.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture life at 1801 MetroWest: upgraded one- and two-bedroom layouts, modern finishes, screened outdoor space, and everyday conveniences designed for connected Southwest Orlando living.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you arrive.</strong> Explore 1801 MetroWest through immersive virtual tours that make it easy to picture the spaces from wherever you are. Walk through a two-bedroom, two-bath apartment and take in the open living area, modern kitchen finishes, hard-surface flooring, and the everyday flow from room to room. Then move into the community experience with tours of the clubhouse and fitness center, where lounge areas, workout space, and resident conveniences come into clearer focus.</p><p>Use these virtual tours as your first look, then compare <a href=\"/floor-plans\">available floor plans</a>, browse more views in the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see 1801 MetroWest in person.</p>",
  "property_copyright": "2026 All Rights Reserved. 1801 Metrowest",
  "property_seo_title_home": "1801 Metrowest |  Apartments in Orlando, FL",
  "property_seo_description_home": "Discover 1801 Metrowest in Orlando! Choose from spacious one & two-bedroom apartments with a pool, fitness center, and bark park. Find your home!",
  "property_seo_title_floorplans": "Floor Plans | Orlando, FL Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at 1801 Metrowest in Orlando, FL. Choose from stylish one and two-bedroom floor plans that suit your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Orlando, FL Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at 1801 Metrowest, Orlando! Enjoy luxury amenities like a resort pool, fitness center, and spacious apartments.",
  "property_seo_title_gallery": "Gallery | Apartments in Orlando, FL",
  "property_seo_description_gallery": "Experience life at 1801 Metrowest, Orlando: beautiful apartments, resort-style amenities, and a vibrant community. Explore our photo gallery!",
  "property_seo_title_virtualtours": "Virtual Tours | 1801 Metrowest Apartments",
  "property_seo_description_virtualtours": "Step inside 1801 Metrowest in Orlando, FL! Experience a virtual tour of our one and two-bedroom apartments and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | 1801 Metrowest Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at 1801 Metrowest in Orlando! Explore modern one and two-bedroom apartments with top amenities using our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Orlando, FL",
  "property_seo_description_neighborhood": "Uncover the vibrant charm of Orlando around 1801 Metrowest. Indulge in local favorites and hidden gems just steps from your new home. Explore now!",
  "property_seo_title_contact": "Contact Us | 1801 Metrowest",
  "property_seo_description_contact": "Connect with us at 1801 Metrowest in Orlando, FL! Our leasing team is ready to help you find the perfect one or two-bedroom apartment. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Orlando, FL",
  "property_seo_description_faqs": "Curious about 1801 Metrowest in Orlando? Our FAQs page has all the answers you need about our amenities, apartment features, and community life.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Orlando, FL",
  "property_seo_description_reviews": "Uncover the vibrant lifestyle at 1801 Metrowest in Orlando, FL. Hear from our residents about spacious apartments, top-notch amenities, and community spirit!",
  "property_seo_title_applynow": "Apply Now | Apartments in Orlando, FL",
  "property_seo_description_applynow": "Experience vibrant living at 1801 Metrowest in Orlando! Enjoy spacious floor plans, upscale amenities, and a welcoming community. Lease your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | 1801 Metrowest",
  "property_seo_description_residentaccess": "Log in to your 1801 Metrowest resident portal in Orlando! Easily pay rent, schedule maintenance, and manage your apartment life all in one place.",
  "property_seo_title_referafriend": "Refer A Friend | 1801 Metrowest",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to 1801 Metrowest in Orlando, FL, and enjoy the perks of community living together. Start sharing today!",
  "property_seo_title_scheduletour": "Schedule a Tour | 1801 Metrowest",
  "property_seo_description_scheduletour": "Explore vibrant living at 1801 Metrowest in Orlando. Schedule your tour today and discover your future home with modern amenities!",
  "property_seo_title_privacy": "Privacy Policy | 1801 Metrowest",
  "property_seo_description_privacy": "At 1801 Metrowest, your privacy matters. Read our policy to see how we protect your info—your comfort is our priority!",
  "property_seo_title_accessibility": "Website Accessibility | 1801 Metrowest",
  "property_seo_description_accessibility": "Discover accessibility at 1801 Metrowest, Orlando, FL. We prioritize digital inclusion for a seamless online experience. Join us!",
  "property_seo_title_sitemap": "Sitemap | 1801 Metrowest",
  "property_seo_description_sitemap": "Uncover the heart of Orlando living at 1801 Metrowest. Navigate our sitemap to find your perfect home and experience elevated apartment living today!",
  "property_seo_title_thankyou": "Thank You | 1801 Metrowest",
  "property_seo_description_thankyou": "Thank you for reaching out to 1801 Metrowest! Our team will be in touch soon to help you find your perfect oasis in vibrant Orlando, FL. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319348",
  "amenities": [
    {
      "id": "custom_0d00d7b7-fc46-4c3c-b615-0e23a988b553",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_423021cc-f8d1-46b6-b266-4a005e395a8f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000607",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "WFH Business Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0a97e43c-2708-4b50-acb3-3dc0c957797f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Resident Lounge w/Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d688f808-2483-4c35-b2ed-98802b586322",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_89544652-61ba-43f8-9a34-3f018a746344",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b5aa382e-217c-4769-8aea-4454b181353e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Wood Burning Fireplaces*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c893c678-55a7-451c-a7dd-de825d8e9788",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "24-Hour Modern Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0271cd5-602b-496a-99b8-e47734bed35b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Hardwood Inspired Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_26e62dc0-d4b3-4ee0-9c1f-74b9415dd801",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3432ca0-0875-4f4c-9d91-22b0117fa7b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000657",
      "title": "Loft Apartments",
      "amount": "0.0000",
      "description": "Loft Style Apartments*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9441f6a5-284e-4f3d-8911-73730a26b61b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b8cc1fb-00fd-4fd1-85ab-3a6c265c9750",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Community Grilling Area/Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1b70e77d-e11c-41d0-b034-43b31ea98ec1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ccb71240-f747-4de1-bc1e-2fbe67c3cbfc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "Concierge Package System",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_482045b5-ca03-490b-a7f0-282b016e5a00",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8b177fdb-8fa8-4314-a39b-78fe97fa5925",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000684",
      "title": "Spin Room",
      "amount": "0.0000",
      "description": "Cycling Studio",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9ce5f030-2669-46cf-9dbb-98feebf5b1a0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Vaulted Ceilings*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b0179df-d884-49fc-b7a4-d44c380e8812",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000691",
      "title": "Technology Package",
      "amount": "0.0000",
      "description": "Wi-Fi and 250 Cable Channels",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_474e93cf-34d3-40c4-b6ba-8f6d97c61fdb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_53362d4f-d07d-4e8c-8abf-388a179dacb3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Spacious Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_641a885a-56c9-411d-ae87-75e0c1d1f7be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-c10d-7298-9ecb-8b66a0375bdc.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a grassy lawn in the foreground.",
        "public_id": "019e8973-c10d-7298-9ecb-8b66a0375bdc",
        "storage_key": "property/5690533913559040/019e8973-c10d-7298-9ecb-8b66a0375bdc.webp",
        "width": 2693,
        "height": 1794
      },
      "title": "Community",
      "description": "Beautifully manicured grounds and well-maintained exteriors create a welcoming atmosphere at this apartment community.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a grassy lawn in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1a8fe139-3668-45c1-9172-db8dcb57e3f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-c0c1-71c8-8bca-9655fcabcfae.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e8973-c0c1-71c8-8bca-9655fcabcfae",
        "storage_key": "property/5690533913559040/019e8973-c0c1-71c8-8bca-9655fcabcfae.webp",
        "width": 2690,
        "height": 1794
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0304b1be-8d05-4e9a-879a-e73d6e5d4224",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-c13c-7720-9af2-1a8fb99ed98c.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and walk-in closet",
        "public_id": "019e8973-c13c-7720-9af2-1a8fb99ed98c",
        "storage_key": "property/5690533913559040/019e8973-c13c-7720-9af2-1a8fb99ed98c.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Chic bathroom featuring a modern vanity, toilet, and a spacious walk-in closet, perfect for any apartment.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and walk-in closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a1d4514d-b736-4d17-8f3d-438034348906",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-bd39-7110-ae60-3cd7593540fd.webp",
      "image_media": {
        "alt_text": "Fitness center with stationary bikes, weight balls, and a bench.",
        "public_id": "019e8973-bd39-7110-ae60-3cd7593540fd",
        "storage_key": "property/5690533913559040/019e8973-bd39-7110-ae60-3cd7593540fd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment and free weights for a comprehensive workout.",
      "link": "",
      "alt_text": "Fitness center with stationary bikes, weight balls, and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d5e93a0-5d17-4ba7-8522-3e2221dc3720",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-7f63-758c-b00e-9464ca9d6f47.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, blue accent wall, and modern decor.",
        "public_id": "019e8973-7f63-758c-b00e-9464ca9d6f47",
        "storage_key": "property/5690533913559040/019e8973-7f63-758c-b00e-9464ca9d6f47.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, a vibrant blue accent wall, and elegant decorative accents.",
      "link": "",
      "alt_text": "Stylish bedroom with a king-size bed, blue accent wall, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_70b7c4e3-8c9f-461d-9028-96695eca11cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-8d12-76aa-a1e4-3c219b90743e.webp",
      "image_media": {
        "alt_text": "Outdoor patio with a white table and chairs under a teal umbrella, lounge seating in the background.",
        "public_id": "019e8973-8d12-76aa-a1e4-3c219b90743e",
        "storage_key": "property/5690533913559040/019e8973-8d12-76aa-a1e4-3c219b90743e.webp",
        "width": 2691,
        "height": 1794
      },
      "title": "Community",
      "description": "Enjoy outdoor living on our beautifully appointed patio, featuring comfortable seating and shaded areas perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Outdoor patio with a white table and chairs under a teal umbrella, lounge seating in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_00ce9272-7808-4b52-8c35-0cf7c57a4864",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-7e9e-75f2-b7d7-f4addfe6a940.webp",
      "image_media": {
        "alt_text": "Tennis and pickleball courts with blue court sections and green surrounding areas, residential buildings in the background.",
        "public_id": "019e8973-7e9e-75f2-b7d7-f4addfe6a940",
        "storage_key": "property/5690533913559040/019e8973-7e9e-75f2-b7d7-f4addfe6a940.webp",
        "width": 2694,
        "height": 1797
      },
      "title": "Community",
      "description": "Enjoy active days on our pristine tennis and pickleball courts, perfect for friendly matches and staying fit. Located within a beautiful residential community.",
      "link": "",
      "alt_text": "Tennis and pickleball courts with blue court sections and green surrounding areas, residential buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6a6e1fb2-5ec9-4da5-b7f3-f2d85bee3923",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-7fce-7697-a913-226ec6a83d5a.webp",
      "image_media": {
        "alt_text": "Lobby with seating area and dining tables.",
        "public_id": "019e8973-7fce-7697-a913-226ec6a83d5a",
        "storage_key": "property/5690533913559040/019e8973-7fce-7697-a913-226ec6a83d5a.webp",
        "width": 2685,
        "height": 1791
      },
      "title": "Community",
      "description": "Modern lobby with comfortable seating and dining tables, perfect for residents to relax or socialize.",
      "link": "",
      "alt_text": "Lobby with seating area and dining tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d63b0ac4-e0ca-4c9f-b439-36a773e86505",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-78b1-77cd-908f-364b610a3c67.webp",
      "image_media": {
        "alt_text": "Outdoor patio seating area with blue sofas, wicker chairs, tables, and teal umbrellas.",
        "public_id": "019e8973-78b1-77cd-908f-364b610a3c67",
        "storage_key": "property/5690533913559040/019e8973-78b1-77cd-908f-364b610a3c67.webp",
        "width": 2692,
        "height": 1796
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor patio area, featuring comfortable seating, shaded umbrellas, and a stylish modern design.",
      "link": "",
      "alt_text": "Outdoor patio seating area with blue sofas, wicker chairs, tables, and teal umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e16c7fa-443f-45a7-ad59-dbf7841a48b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-784d-708a-b16e-f9a42ec25dd7.webp",
      "image_media": {
        "alt_text": "Modern living room with a blue sofa, grey chairs, abstract art, and a large window.",
        "public_id": "019e8973-784d-708a-b16e-f9a42ec25dd7",
        "storage_key": "property/5690533913559040/019e8973-784d-708a-b16e-f9a42ec25dd7.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living room, featuring a plush blue sofa, elegant grey armchairs, and striking abstract art.",
      "link": "",
      "alt_text": "Modern living room with a blue sofa, grey chairs, abstract art, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9481ee26-5f93-4d55-bcb4-05a2b7cb618a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-79ec-732c-8c84-2114d8df8d3d.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with island seating and a dining table.",
        "public_id": "019e8973-79ec-732c-8c84-2114d8df8d3d",
        "storage_key": "property/5690533913559040/019e8973-79ec-732c-8c84-2114d8df8d3d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and modern kitchen and dining area, perfect for entertaining or everyday meals. Features include an island with seating and a stylish dining table.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with island seating and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_95dd11b3-613f-412a-b774-0a5e893d7d8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-6cec-70d9-9158-38abd0e6a5c9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e8973-6cec-70d9-9158-38abd0e6a5c9",
        "storage_key": "property/5690533913559040/019e8973-6cec-70d9-9158-38abd0e6a5c9.webp",
        "width": 2690,
        "height": 1794
      },
      "title": "Community",
      "description": "Relax by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ccb6d288-8ff1-4dc2-b093-a21122ea7647",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-6aa7-72a8-80b3-ecdfce257c87.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019e8973-6aa7-72a8-80b3-ecdfce257c87",
        "storage_key": "property/5690533913559040/019e8973-6aa7-72a8-80b3-ecdfce257c87.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, weight machines, and free weights for residents.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_73b71846-9e0f-496c-9b8f-1e0ce8717393",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-690c-753d-b727-2b151e8b801a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity with a chrome faucet.",
        "public_id": "019e8973-690c-753d-b727-2b151e8b801a",
        "storage_key": "property/5690533913559040/019e8973-690c-753d-b727-2b151e8b801a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and convenience in this beautifully appointed apartment bathroom, featuring a sleek vanity and a relaxing bathtub.",
      "link": "",
      "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity with a chrome faucet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d1312354-46f6-4541-b759-8181be5adcfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-4837-769e-9d22-2c57b3f56c6a.webp",
      "image_media": {
        "alt_text": "Modern apartment complex lobby with a front desk and seating area.",
        "public_id": "019e8973-4837-769e-9d22-2c57b3f56c6a",
        "storage_key": "property/5690533913559040/019e8973-4837-769e-9d22-2c57b3f56c6a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our stunning apartment lobby, featuring a sleek front desk, comfortable seating, and elegant decor. Experience a touch of luxury from the moment you arrive.",
      "link": "",
      "alt_text": "Modern apartment complex lobby with a front desk and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e3f26ca6-dbf8-4dc1-9f8c-0a2a41ffcd0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-489a-718f-9cbe-64641e70a174.webp",
      "image_media": {
        "alt_text": "MetroWest Premier Apartments monument sign and entrance.",
        "public_id": "019e8973-489a-718f-9cbe-64641e70a174",
        "storage_key": "property/5690533913559040/019e8973-489a-718f-9cbe-64641e70a174.webp",
        "width": 2355,
        "height": 1572
      },
      "title": "Community",
      "description": "Welcome to MetroWest Premier Apartments, featuring a prominent monument sign at the property entrance.",
      "link": "",
      "alt_text": "MetroWest Premier Apartments monument sign and entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_609e900b-adb5-497b-8550-867a6c32fbdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-4845-7118-9974-5d1f685c6250.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and walk-in closet.",
        "public_id": "019e8973-4845-7118-9974-5d1f685c6250",
        "storage_key": "property/5690533913559040/019e8973-4845-7118-9974-5d1f685c6250.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a large dresser with a mirror, and a convenient walk-in closet. Perfect for relaxation and storage.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_541ce6f0-674d-40f2-8cf4-256596ac13a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-37d5-7478-a03f-01bdf30a4967.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with granite countertops, stainless steel appliances, and a dark wood table set for dinner.",
        "public_id": "019e8973-37d5-7478-a03f-01bdf30a4967",
        "storage_key": "property/5690533913559040/019e8973-37d5-7478-a03f-01bdf30a4967.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and stylish kitchen and dining area, perfect for cooking and entertaining. Features granite countertops, stainless steel appliances, and a contemporary dining set.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with granite countertops, stainless steel appliances, and a dark wood table set for dinner.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f8826c08-170b-435f-bd09-de0dca807115",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-40e7-76ff-903b-29ffc585c0c2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a sink.",
        "public_id": "019e8973-40e7-76ff-903b-29ffc585c0c2",
        "storage_key": "property/5690533913559040/019e8973-40e7-76ff-903b-29ffc585c0c2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring sleek cabinetry, modern appliances, and ample counter space for your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a92d4a5c-1e87-4fd8-b51c-55dbc9002102",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-36aa-721c-8dd3-36f82a2209b3.webp",
      "image_media": {
        "alt_text": "Gym with weight machines and cardio equipment.",
        "public_id": "019e8973-36aa-721c-8dd3-36f82a2209b3",
        "storage_key": "property/5690533913559040/019e8973-36aa-721c-8dd3-36f82a2209b3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of weight machines and cardio equipment for residents.",
      "link": "",
      "alt_text": "Gym with weight machines and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_41ce6dcb-9d1c-408c-bdca-7d7c7298361c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-3713-7045-b535-ff6c833ccf0a.webp",
      "image_media": {
        "alt_text": "Lobby and seating area with a coffee bar and a Starbucks sign.",
        "public_id": "019e8973-3713-7045-b535-ff6c833ccf0a",
        "storage_key": "property/5690533913559040/019e8973-3713-7045-b535-ff6c833ccf0a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, complete with a coffee bar and comfortable seating. Perfect for catching up with neighbors or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Lobby and seating area with a coffee bar and a Starbucks sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aa4c17c8-3c63-408a-b8bd-e0d347e20096",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8972-efef-723b-ab7e-581080c3dcff.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with green spaces and landscaping.",
        "public_id": "019e8972-efef-723b-ab7e-581080c3dcff",
        "storage_key": "property/5690533913559040/019e8972-efef-723b-ab7e-581080c3dcff.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Discover comfortable living in this well-maintained multifamily property, featuring lush green spaces and a beautifully landscaped exterior.",
      "link": "",
      "alt_text": "Exterior view of a multifamily apartment building with green spaces and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_48bb33e8-5ff5-484a-9cc7-9885db1f31ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-02ac-7359-a434-ec09fcf21dc3.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio with grilling station and seating area near the pool.",
        "public_id": "019e8973-02ac-7359-a434-ec09fcf21dc3",
        "storage_key": "property/5690533913559040/019e8973-02ac-7359-a434-ec09fcf21dc3.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our outdoor grilling station, complete with multiple grills and comfortable seating. Adjacent to the resort-style pool, it's the perfect spot for entertaining.",
      "link": "",
      "alt_text": "Outdoor covered patio with grilling station and seating area near the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ad11d8b0-828a-4dc9-a748-e26b5b81d558",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-383f-733a-98d9-78d1225d36f0.webp",
      "image_media": {
        "alt_text": "Wicker chairs and tables arranged around a sparkling swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e8973-383f-733a-98d9-78d1225d36f0",
        "storage_key": "property/5690533913559040/019e8973-383f-733a-98d9-78d1225d36f0.webp",
        "width": 1681,
        "height": 1121
      },
      "title": "Community",
      "description": "Relax and unwind by our resort-style swimming pool, complete with comfortable seating and lush landscaping. Perfect for soaking up the sun or enjoying a cool dip.",
      "link": "",
      "alt_text": "Wicker chairs and tables arranged around a sparkling swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_58dd0302-1aa5-4417-90c6-c10fe6a9fc76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-0198-7273-84c5-bae5a88eb7f0.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with a coffee bar and dining tables in a modern apartment complex lounge.",
        "public_id": "019e8973-0198-7273-84c5-bae5a88eb7f0",
        "storage_key": "property/5690533913559040/019e8973-0198-7273-84c5-bae5a88eb7f0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish resident lounge, featuring a fully equipped coffee bar, comfortable seating, and ample dining space for socializing or catching up on work.",
      "link": "",
      "alt_text": "Comfortable seating area with a coffee bar and dining tables in a modern apartment complex lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39f9b2df-b6f6-4604-9a0b-092924eff5d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-0207-708a-9d00-4eb7aca5df1f.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with blue sofa, gray chairs, and granite countertops.",
        "public_id": "019e8973-0207-708a-9d00-4eb7aca5df1f",
        "storage_key": "property/5690533913559040/019e8973-0207-708a-9d00-4eb7aca5df1f.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Step into a stylish and comfortable living space, featuring a sleek blue sofa, elegant gray seating, and a modern kitchen island perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with blue sofa, gray chairs, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_159198c8-9f72-4842-a89e-d7ead3a8a697",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-01ef-7567-85cf-ecfd461d5b66.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, rowing machine, weight machines, and free weights.",
        "public_id": "019e8973-01ef-7567-85cf-ecfd461d5b66",
        "storage_key": "property/5690533913559040/019e8973-01ef-7567-85cf-ecfd461d5b66.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with modern cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, rowing machine, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_26d3e796-860d-40f5-b3cc-2f1cadf68c77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8972-efef-723b-ab7e-56b6cef157a1.webp",
      "image_media": {
        "alt_text": "Stylish living room and dining area with a blue sofa, accent chairs, and a dining table.",
        "public_id": "019e8972-efef-723b-ab7e-56b6cef157a1",
        "storage_key": "property/5690533913559040/019e8972-efef-723b-ab7e-56b6cef157a1.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Experience modern comfort in this beautifully staged living and dining area. Features plush seating, elegant decor, and a spacious layout perfect for entertaining.",
      "link": "",
      "alt_text": "Stylish living room and dining area with a blue sofa, accent chairs, and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e9e1f970-6dc2-4609-9b84-0920691ae4aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8972-efef-723b-ab7e-51ee35733669.webp",
      "image_media": {
        "alt_text": "Dining room and kitchen with granite countertops, stainless steel appliances, and seating for four.",
        "public_id": "019e8972-efef-723b-ab7e-51ee35733669",
        "storage_key": "property/5690533913559040/019e8972-efef-723b-ab7e-51ee35733669.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Enjoy a spacious dining room and modern kitchen, perfect for entertaining. Features include granite countertops, stainless steel appliances, and ample cabinet space.",
      "link": "",
      "alt_text": "Dining room and kitchen with granite countertops, stainless steel appliances, and seating for four.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d35ab1e5-88d6-432a-887f-7fbf71697d73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8972-eed5-7321-aa88-589200693bc4.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e8972-eed5-7321-aa88-589200693bc4",
        "storage_key": "property/5690533913559040/019e8972-eed5-7321-aa88-589200693bc4.webp",
        "width": 1659,
        "height": 1106
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our stunning resort-style pool, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a8cc1f2e-20a3-44dc-a611-a22ee891257d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8972-ecdb-7102-9fac-261e3464d2c0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a laundry closet.",
        "public_id": "019e8972-ecdb-7102-9fac-261e3464d2c0",
        "storage_key": "property/5690533913559040/019e8972-ecdb-7102-9fac-261e3464d2c0.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Apartment",
      "description": "Step into this modern kitchen featuring sleek granite countertops, ample cabinet space, and a convenient laundry closet. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a laundry closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a5da542a-74ef-4c8e-babc-97d5f5c38029",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8972-ee23-77bb-b87f-ab0fcedcc634.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a queen-size bed, dresser, and nightstand.",
        "public_id": "019e8972-ee23-77bb-b87f-ab0fcedcc634",
        "storage_key": "property/5690533913559040/019e8972-ee23-77bb-b87f-ab0fcedcc634.webp",
        "width": 2682,
        "height": 1788
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed and ample storage.",
      "link": "",
      "alt_text": "Primary bedroom with a queen-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_011e7684985ee29eb7012b80",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Mecatos Bakery & Café",
      "poi_type": "Restaurants",
      "poi_address": "2900 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Warm bakery and cafe known for Colombian delights along with lattes and coffee.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1517-ea52-72f2-87cd-60d3ba7e319b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-ea52-72f2-87cd-60d3ba7e319b",
        "storage_key": "property/5690533913559040/019f1517-ea52-72f2-87cd-60d3ba7e319b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mecatoscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=162418754459240832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mecatos-bakery--caf",
      "poi_latitude": "28.5118037",
      "poi_longitude": "-81.45976189999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-317-5046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e364b18618c9",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-48zJMp554gRgIlnJP8GQQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_4d2add9b3c48fe0d6c1e2dbd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Sea-San Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "3120 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Lively, friendly, cozy haunt for sushi, featuring specialty rolls and all-you-can-eat options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-b720-7088-b35c-4ee04f156103.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-b720-7088-b35c-4ee04f156103",
        "storage_key": "property/5690533913559040/019f194a-b720-7088-b35c-4ee04f156103.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://seasansushibar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17170536061107746823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-san-sushi-bar",
      "poi_latitude": "28.5097881",
      "poi_longitude": "-81.4597405",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-233-4472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e364b18618c9",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9__V8y1554gRB7hc_ZL_Se4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_7ce06e8cdb6cbf0f732e9edf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Tropical Smoothie Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3120 S Kirkman Rd Ste 5E, Orlando, FL 32811, USA",
      "poi_short_description": "Health-conscious cafe chain featuring a menu of custom smoothies, sandwiches & wraps.",
      "poi_long_description": "Health-conscious cafe chain featuring a menu of custom smoothies, sandwiches & wraps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-b4d8-71fe-af42-d55b37ba829d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-b4d8-71fe-af42-d55b37ba829d",
        "storage_key": "property/5690533913559040/019de3c7-b4d8-71fe-af42-d55b37ba829d.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://locations.tropicalsmoothiecafe.com/fl/orlando/3120-s.-kirkman-road?y_source=1_MTA5MDM4MTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16101276150366773768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tropical-smoothie-cafe",
      "poi_latitude": "28.509789",
      "poi_longitude": "-81.459726",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-601-7982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e364b18618c9",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqdWovDp554gRCKIUvVk5c98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "juice_shop"
    },
    {
      "id": "ec_c230acaa5a92783a4b8025ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "EZ Crab Shack",
      "poi_type": "Restaurants",
      "poi_address": "805 S Kirkman Rd #103, Orlando, FL 32811, USA",
      "poi_short_description": "Sea-based joint specializing in crab and seafood boils, plus wings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1517-fb2d-71ae-a374-fb6e8fad8fe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-fb2d-71ae-a374-fb6e8fad8fe2",
        "storage_key": "property/5690533913559040/019f1517-fb2d-71ae-a374-fb6e8fad8fe2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1288193949055545412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ez-crab-shack",
      "poi_latitude": "28.5315651",
      "poi_longitude": "-81.4584104",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-237-9995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e364b18618c9",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVxNHpJ554gRRHBDT5KV4BE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_3d7eba3bb02f2303e6c8a259",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Island Rhythms Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3749 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-b67a-725d-9c1c-684ed0a496db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-b67a-725d-9c1c-684ed0a496db",
        "storage_key": "property/5690533913559040/019f194a-b67a-725d-9c1c-684ed0a496db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18384067046116061353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "island-rhythms-cafe",
      "poi_latitude": "28.5041098",
      "poi_longitude": "-81.4579813",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-930-0462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e364b18618c9",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYbGjPR554gRqXC2UpNTIf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "caribbean_restaurant"
    },
    {
      "id": "ec_a3f8b918ba8ce2a9ead6b80f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Flippers Pizza Co. - Dr. Phillips",
      "poi_type": "Restaurants",
      "poi_address": "7339 W Sand Lake Rd, Orlando, FL 32819, USA",
      "poi_short_description": "Casual pizza chain serving brick-oven pies & other Italian eats, plus beer & wine.",
      "poi_long_description": "Casual pizza chain serving brick-oven pies & other Italian eats, plus beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1517-e4ab-755e-a4d6-5bfe142d9bd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-e4ab-755e-a4d6-5bfe142d9bd4",
        "storage_key": "property/5690533913559040/019f1517-e4ab-755e-a4d6-5bfe142d9bd4.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "https://www.flipperspizzaco.com/dr-phillips-orlando",
      "poi_directions_map_url": "https://maps.google.com/?cid=11856559156251224408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flippers-pizza-co---dr-phillips",
      "poi_latitude": "28.4503903",
      "poi_longitude": "-81.48089379999999",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 407-352-2213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e364b18618c9",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8znpTah_54gRWGnC3rv1iqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_0572b6159df188ef6109ae01",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Agave Azul Kirkman",
      "poi_type": "Restaurants",
      "poi_address": "4750 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Casual Mexican fare served in a vibrant space with a party vibe, lots of tequila & outdoor tables.",
      "poi_long_description": "Casual Mexican fare served in a vibrant space with a party vibe, lots of tequila & outdoor tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1517-e9e7-73eb-9e3d-badc7269448b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-e9e7-73eb-9e3d-badc7269448b",
        "storage_key": "property/5690533913559040/019f1517-e9e7-73eb-9e3d-badc7269448b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://agaveazulcocinamex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7439970734989302585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "agave-azul-kirkman",
      "poi_latitude": "28.4927966",
      "poi_longitude": "-81.460736",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-704-6930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e364b18618c9",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_UYlx81-54gROdtW_vYVQGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_fc5a93e49f7ed1152ee8cb5e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "El Potro Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4666 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Casual Mexican restaurant serving up a menu of classic dishes, including tacos & enchiladas.",
      "poi_long_description": "Casual Mexican restaurant serving up a menu of classic dishes, including tacos & enchiladas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-bd50-702d-9ec2-f10736292351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-bd50-702d-9ec2-f10736292351",
        "storage_key": "property/5690533913559040/019de3c7-bd50-702d-9ec2-f10736292351.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://orlandoelpotro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16466257241253289256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-potro-mexican-restaurant",
      "poi_latitude": "28.4941962",
      "poi_longitude": "-81.4612361",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-781-0395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e364b18618c9",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxK1ps1-54gRKB0bDbjlg-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_cfdd55ba56ea50789af67e6d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4752 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-bb0d-7518-ae93-af6d248ddde2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-bb0d-7518-ae93-af6d248ddde2",
        "storage_key": "property/5690533913559040/019de3c7-bb0d-7518-ae93-af6d248ddde2.webp",
        "width": 1280,
        "height": 940
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/fl/kirkman-and-conroy-road?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13565201507875495626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "28.4926065",
      "poi_longitude": "-81.4596396",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-295-9034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e364b18618c9",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRTQmx81-54gRyh6DX-ZGQbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_0593df1e991ddaa45a5ed674",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Firehouse Subs Kirkman",
      "poi_type": "Restaurants",
      "poi_address": "4894 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_long_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1517-f12d-7449-b38b-57ee956ac796.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-f12d-7449-b38b-57ee956ac796",
        "storage_key": "property/5690533913559040/019f1517-f12d-7449-b38b-57ee956ac796.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.firehousesubs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1826833499638327077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firehouse-subs-kirkman",
      "poi_latitude": "28.4915216",
      "poi_longitude": "-81.460112",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-447-9866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e364b18618c9",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5SUNis1-54gRJee5kWM3Whk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_f99bddd7320e35bbad385440",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Sloppy Taco Palace",
      "poi_type": "Restaurants",
      "poi_address": "4892 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Chill local watering hole offering unique tacos & other casual bites.",
      "poi_long_description": "Chill local watering hole offering unique tacos & other casual bites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-b783-774d-8a9a-400e61244ebd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-b783-774d-8a9a-400e61244ebd",
        "storage_key": "property/5690533913559040/019f194a-b783-774d-8a9a-400e61244ebd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sloppytacoorlando.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15689119441289099107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sloppy-taco-palace",
      "poi_latitude": "28.4915793",
      "poi_longitude": "-81.46020089999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-574-6474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e364b18618c9",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_YVcc5-54gRYze24AHzutk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_7f63ad01ceb9a23f5263a6c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Bubbalou's Bodacious Bar-B-Que",
      "poi_type": "Restaurants",
      "poi_address": "5818 Conroy Rd, Orlando, FL 32835, USA",
      "poi_short_description": "Unpretentious link in a longtime chain serving a vast menu of ribs, sandwiches & sides.",
      "poi_long_description": "Unpretentious link in a longtime chain serving a vast menu of ribs, sandwiches & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1517-e915-7214-a5c9-7839c91e54b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-e915-7214-a5c9-7839c91e54b4",
        "storage_key": "property/5690533913559040/019f1517-e915-7214-a5c9-7839c91e54b4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kirkman.bubbalous.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15616216618251093981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bubbalous-bodacious-bar-b-que",
      "poi_latitude": "28.493332",
      "poi_longitude": "-81.460847",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-295-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e364b18618c9",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e364b18618c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB6R0CtJ-54gR3Ydoqkbyt9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_bf914fcde609fa0c1581aa28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "Metro Crossings, 2573 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-bc75-734c-9a3d-525a2cdcd460.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-bc75-734c-9a3d-525a2cdcd460",
        "storage_key": "property/5690533913559040/019f194a-bc75-734c-9a3d-525a2cdcd460.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/18443/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2331418390606184996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "28.51526",
      "poi_longitude": "-81.45831",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-822-0992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fbe8-725e-8b8c-6e2ddadb342a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fbe8-725e-8b8c-6e2ddadb342a",
        "storage_key": "property/5690533913559040/019de3c7-fbe8-725e-8b8c-6e2ddadb342a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJRRUFgTx554gRJALlgqzcWiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_7b062f9bc7efc1acd5bbf812",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2500 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "This chain carries groceries and clothing, and offers a variety of other items for the home, from toys to electronics.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-c2c6-7058-8cde-59c69e893f7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-c2c6-7058-8cde-59c69e893f7f",
        "storage_key": "property/5690533913559040/019de3c7-c2c6-7058-8cde-59c69e893f7f.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1220-orlando-fl/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11903804438079064228&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "28.5154993",
      "poi_longitude": "-81.46274369999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-290-6977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a948-7038-be6b-a8d3ab39ac1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a948-7038-be6b-a8d3ab39ac1b",
        "storage_key": "property/5690533913559040/019de3c5-a948-7038-be6b-a8d3ab39ac1b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNxECXiN554gRpMhrPxHPMqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_dc46691f1ca2c4cf8eb9dd3e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Publix Super Market at Kirkman Oaks Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "4606 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-b94b-7178-8287-62ad69dbe157.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-b94b-7178-8287-62ad69dbe157",
        "storage_key": "property/5690533913559040/019f194a-b94b-7178-8287-62ad69dbe157.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=331&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=3038135033188809005&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-kirkman-oaks-shopping-center",
      "poi_latitude": "28.4952221",
      "poi_longitude": "-81.4611554",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-293-7673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fbd5-751f-88e3-61151ab00dd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fbd5-751f-88e3-61151ab00dd7",
        "storage_key": "property/5690533913559040/019de3c7-fbd5-751f-88e3-61151ab00dd7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1WAD81-54gRLXnjSLefKSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_8d7cd12ce54ef061ae38ee4d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Winn-Dixie",
      "poi_type": "Shopping & Retail",
      "poi_address": "1401 S Hiawassee Rd, Orlando, FL 32835, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-bba3-7308-a52a-090a7c1849eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-bba3-7308-a52a-090a7c1849eb",
        "storage_key": "property/5690533913559040/019f194a-bba3-7308-a52a-090a7c1849eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12435033872551061416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winn-dixie",
      "poi_latitude": "28.5248883",
      "poi_longitude": "-81.4699306",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-521-9333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fbd5-751f-88e3-61151ab00dd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fbd5-751f-88e3-61151ab00dd7",
        "storage_key": "property/5690533913559040/019de3c7-fbd5-751f-88e3-61151ab00dd7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZ7gTh5554gRqCdbZ2wdkqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_d0a5b3218e14e16cf275e894",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "+ Brazil Food Mart - Rodriguinho’s",
      "poi_type": "Shopping & Retail",
      "poi_address": "3120 S Kirkman Rd S, Orlando, FL 32811, USA",
      "poi_short_description": "Brazilian grocery featuring meats, produce & lots of bakery items, including pao de sal & empanadas.",
      "poi_long_description": "Brazilian grocery featuring meats, produce & lots of bakery items, including pao de sal & empanadas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-bc89-757a-83bd-318eb40dba96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-bc89-757a-83bd-318eb40dba96",
        "storage_key": "property/5690533913559040/019f194a-bc89-757a-83bd-318eb40dba96.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.maisbrazilfoodmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5357230046373791980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "-brazil-food-mart---rodriguinhos",
      "poi_latitude": "28.5103371",
      "poi_longitude": "-81.460081",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-293-3330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fbd5-751f-88e3-61151ab00dd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fbd5-751f-88e3-61151ab00dd7",
        "storage_key": "property/5690533913559040/019de3c7-fbd5-751f-88e3-61151ab00dd7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMYGClDp554gR7Mgo5le0WEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_52ecbeb25f94427b6f1b91d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Big Bazaar",
      "poi_type": "Shopping & Retail",
      "poi_address": "485 S Kirkman Rd Unit 108, Orlando, FL 32811, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-be23-7291-a596-ce1add239136.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-be23-7291-a596-ce1add239136",
        "storage_key": "property/5690533913559040/019f194a-be23-7291-a596-ce1add239136.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12356883336545129854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-bazaar",
      "poi_latitude": "28.5351859",
      "poi_longitude": "-81.4573984",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-440-3222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fbd5-751f-88e3-61151ab00dd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fbd5-751f-88e3-61151ab00dd7",
        "storage_key": "property/5690533913559040/019de3c7-fbd5-751f-88e3-61151ab00dd7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPVvVMP1554gRflW3zex3fKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_7b88a860abe3b094b11a33a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "4720 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-bd54-745f-baa3-062fe299ace1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-bd54-745f-baa3-062fe299ace1",
        "storage_key": "property/5690533913559040/019f194a-bd54-745f-baa3-062fe299ace1.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4720+s+kirkman+rd-orlando-fl-32811/id=15332",
      "poi_directions_map_url": "https://maps.google.com/?cid=16460055284121141222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "28.4935009",
      "poi_longitude": "-81.45955149999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-293-8458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAXHBlM1-54gR5v9UYRLdbeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_c734cc6a79d55230dda7e6c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Kirkman Shoppes",
      "poi_type": "Shopping & Retail",
      "poi_address": "4732 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Shopping mall featuring retail, dining, personal services, and a liquor store.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-c1d4-749b-9998-ea964e7efeb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-c1d4-749b-9998-ea964e7efeb1",
        "storage_key": "property/5690533913559040/019f194a-c1d4-749b-9998-ea964e7efeb1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regencycenters.com/property/detail/80047/Kirkman-Shoppes",
      "poi_directions_map_url": "https://maps.google.com/?cid=4460390815848772572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kirkman-shoppes",
      "poi_latitude": "28.4924369",
      "poi_longitude": "-81.460081",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-664-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a948-7038-be6b-a8d3ab39ac1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a948-7038-be6b-a8d3ab39ac1b",
        "storage_key": "property/5690533913559040/019de3c5-a948-7038-be6b-a8d3ab39ac1b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPQN7cc5-54gR3LMUmtB95j0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_0d262d565c32da472f40e2fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "7-Eleven Fuel",
      "poi_type": "Transportation & Transit",
      "poi_address": "4690 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Convenience chain offering grab-&-go bites & beverages, plus assorted newsstand items.",
      "poi_long_description": "Convenience chain offering grab-&-go bites & beverages, plus assorted newsstand items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-c24f-743b-9958-69c7b862c9aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-c24f-743b-9958-69c7b862c9aa",
        "storage_key": "property/5690533913559040/019f194a-c24f-743b-9958-69c7b862c9aa.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.7-eleven.com/locations/fl/orlando/4690-s-kirkman-rd-27504?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8835001839460825745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven-fuel",
      "poi_latitude": "28.49428",
      "poi_longitude": "-81.459311",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-295-7905",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-dfa0-767e-977a-e503edb1e94c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f194a-dfa0-767e-977a-e503edb1e94c",
        "storage_key": "property/5690533913559040/019f194a-dfa0-767e-977a-e503edb1e94c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aBBlc1-54gRkTr89lw7nHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_2fef012047d76b1053c1d0e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Dollar General Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6536 Old Winter Garden Rd, Orlando, FL 32835, USA",
      "poi_short_description": "Chain stocked with household goods, snacks and apparel, plus groceries like produce and bread.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-c5fd-716c-a7d3-5f4352a28710.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-c5fd-716c-a7d3-5f4352a28710",
        "storage_key": "property/5690533913559040/019f194a-c5fd-716c-a7d3-5f4352a28710.webp",
        "width": 1280,
        "height": 811
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/fl/orlando/9858",
      "poi_directions_map_url": "https://maps.google.com/?cid=3583060474054655650&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general-market",
      "poi_latitude": "28.5382229",
      "poi_longitude": "-81.4723863",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-300-0575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fbd5-751f-88e3-61151ab00dd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fbd5-751f-88e3-61151ab00dd7",
        "storage_key": "property/5690533913559040/019de3c7-fbd5-751f-88e3-61151ab00dd7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEd7w-obtx1IRoj7FbISWuTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_06ddfdfe66ba3830c555df2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Valencia College West Campus",
      "poi_type": "Education",
      "poi_address": "SSB - Student Services Building, 1800 S Kirkman Rd Bldg 11, Room 104, Orlando, FL 32811, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-417f-77b1-8727-271d0046662c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c5-417f-77b1-8727-271d0046662c",
        "storage_key": "property/5690533913559040/019de3c5-417f-77b1-8727-271d0046662c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://valenciacollege.edu/locations/west/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6740659856168592299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valencia-college-west-campus",
      "poi_latitude": "28.5213883",
      "poi_longitude": "-81.46483549999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-299-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a912-74dd-97dc-736721bea8fb",
        "storage_key": "property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0XspYxh554gRqyOq9myii10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_c22200ae13f6085d71ddebf0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "MetroWest Elementary School",
      "poi_type": "Education",
      "poi_address": "1801 Lake Vilma Dr, Orlando, FL 32835, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-c9d5-7468-96a0-dd40adb221c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-c9d5-7468-96a0-dd40adb221c4",
        "storage_key": "property/5690533913559040/019de3c7-c9d5-7468-96a0-dd40adb221c4.webp",
        "width": 1265,
        "height": 949
      },
      "poi_business_url": "https://metrowestes.ocps.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10985807524690550433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metrowest-elementary-school",
      "poi_latitude": "28.5219921",
      "poi_longitude": "-81.4938081",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-296-6450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a912-74dd-97dc-736721bea8fb",
        "storage_key": "property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx9KycMB454gRoV7-B71tdZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_b09ca8d89720e7aff4fd63a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Eagle's Nest Elementary School",
      "poi_type": "Education",
      "poi_address": "5353 Metrowest Blvd, Orlando, FL 32811, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://eaglesnestes.ocps.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5553027639539822502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eagles-nest-elementary-school",
      "poi_latitude": "28.5170663",
      "poi_longitude": "-81.45313279999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-521-2795",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a912-74dd-97dc-736721bea8fb",
        "storage_key": "property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-ZHL-j5554gRpm-yijdREE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_f88ba1b4a79cf2ae32dcd00d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Millennia Elementary School",
      "poi_type": "Education",
      "poi_address": "5301 Cypress Creek Blvd, Orlando, FL 32811, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1517-f930-7053-bb16-cf47e361d786.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-f930-7053-bb16-cf47e361d786",
        "storage_key": "property/5690533913559040/019f1517-f930-7053-bb16-cf47e361d786.webp",
        "width": 768,
        "height": 1024
      },
      "poi_business_url": "https://millenniaes.ocps.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17790472736523381987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "millennia-elementary-school",
      "poi_latitude": "28.4856316",
      "poi_longitude": "-81.4443028",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-355-5730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a912-74dd-97dc-736721bea8fb",
        "storage_key": "property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7TChs7B-54gR42y_JrJ05PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_139f5c9e3121e2ee06d0a273",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Dr. Phillips High School",
      "poi_type": "Education",
      "poi_address": "6500 Turkey Lake Rd, Orlando, FL 32819, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-c7fb-72fc-990b-00d3aee19db4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-c7fb-72fc-990b-00d3aee19db4",
        "storage_key": "property/5690533913559040/019de3c7-c7fb-72fc-990b-00d3aee19db4.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://drphillipshs.ocps.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14985002615738486559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dr-phillips-high-school",
      "poi_latitude": "28.4698511",
      "poi_longitude": "-81.4769007",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 407-355-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a912-74dd-97dc-736721bea8fb",
        "storage_key": "property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOXrfyh5_54gRH09kLXxs9c8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_194f8195dc49bd941f167791",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Bishop Moore Catholic High School",
      "poi_type": "Education",
      "poi_address": "3901 Edgewater Dr, Orlando, FL 32804, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-c6c4-700b-8f4c-2ecf6a55742a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-c6c4-700b-8f4c-2ecf6a55742a",
        "storage_key": "property/5690533913559040/019f194a-c6c4-700b-8f4c-2ecf6a55742a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.bishopmoore.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16497600759107524674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bishop-moore-catholic-high-school",
      "poi_latitude": "28.5871705",
      "poi_longitude": "-81.3905237",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 407-293-7561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a912-74dd-97dc-736721bea8fb",
        "storage_key": "property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI0-eI4Jw54gRQpjRfHtA8-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_125ac19802d30aa53d219b1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Lake Como School",
      "poi_type": "Education",
      "poi_address": "2450 E Gore St, Orlando, FL 32806, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://lakecomok8.ocps.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17165410431449775837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-como-school",
      "poi_latitude": "28.5312209",
      "poi_longitude": "-81.3507101",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 407-897-6430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a912-74dd-97dc-736721bea8fb",
        "storage_key": "property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIb9p9Ol754gR3T5ZVtfJN-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_ce9ebb11ea7ee7b21b6b0dd9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Orlando Gifted Academy",
      "poi_type": "Education",
      "poi_address": "1121 N Fern Creek Ave, Orlando, FL 32803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-cb11-760d-8c8a-612c8ff60e24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-cb11-760d-8c8a-612c8ff60e24",
        "storage_key": "property/5690533913559040/019f194a-cb11-760d-8c8a-612c8ff60e24.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://orlandogiftedacademy.ocps.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4261893441085890242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-gifted-academy",
      "poi_latitude": "28.6048693",
      "poi_longitude": "-81.3622839",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 407-897-6410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a912-74dd-97dc-736721bea8fb",
        "storage_key": "property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNbeyIQZ754gRwt59EoFJJTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_0305a8250dc60348377a4256",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Orange Technical College",
      "poi_type": "Education",
      "poi_address": "301 W Amelia St, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-c62e-7315-8144-aa7515c7cc84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-c62e-7315-8144-aa7515c7cc84",
        "storage_key": "property/5690533913559040/019f194a-c62e-7315-8144-aa7515c7cc84.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orangetechcollege.net/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=10508766921672025819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orange-technical-college",
      "poi_latitude": "28.550328",
      "poi_longitude": "-81.383783",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 407-246-7060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a912-74dd-97dc-736721bea8fb",
        "storage_key": "property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIdgzEPh654gR2-aiYdaj1pE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_e56f098db9278272f76b634d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Universal Orlando Boys & Girls Club",
      "poi_type": "Education",
      "poi_address": "5055 Raleigh St, Orlando, FL 32811, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://bgccf.org/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14124362746078201961&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "universal-orlando-boys--girls-club",
      "poi_latitude": "28.5282948",
      "poi_longitude": "-81.4462151",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-298-0680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a912-74dd-97dc-736721bea8fb",
        "storage_key": "property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8YvvTGx554gRaYjAXhXRA8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_534fe19a71968794173ccbb2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Universal CityWalk Orlando",
      "poi_type": "Shopping & Retail",
      "poi_address": "6000 Universal Blvd, Orlando, FL 32819, USA",
      "poi_short_description": "Energetic attraction at Universal Orlando featuring a variety of restaurants, shops & family shows.",
      "poi_long_description": "Energetic attraction at Universal Orlando featuring a variety of restaurants, shops & family shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-3703-75d9-8c82-e81ac1c824c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c5-3703-75d9-8c82-e81ac1c824c1",
        "storage_key": "property/5690533913559040/019de3c5-3703-75d9-8c82-e81ac1c824c1.webp",
        "width": 580,
        "height": 464
      },
      "poi_business_url": "https://www.universalorlando.com/web/en/us/theme-parks/citywalk",
      "poi_directions_map_url": "https://maps.google.com/?cid=8937435963939553529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "universal-citywalk-orlando",
      "poi_latitude": "28.4729899",
      "poi_longitude": "-81.46588679999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 407-363-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a948-7038-be6b-a8d3ab39ac1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a948-7038-be6b-a8d3ab39ac1b",
        "storage_key": "property/5690533913559040/019de3c5-a948-7038-be6b-a8d3ab39ac1b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEyMWSOd-54gR-QBrGagmCHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_ad0ce8a399f6b0df0b648d71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Universal Studios Florida",
      "poi_type": "Entertainment",
      "poi_address": "6000 Universal Blvd, Orlando, FL 32819, USA",
      "poi_short_description": "Famous, sprawling amusement park featuring movie-themed rides, attractions & entertainment.",
      "poi_long_description": "Famous, sprawling amusement park featuring movie-themed rides, attractions & entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-4179-768a-8378-572eb61ac2d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c5-4179-768a-8378-572eb61ac2d9",
        "storage_key": "property/5690533913559040/019de3c5-4179-768a-8378-572eb61ac2d9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.universalorlando.com/web/en/us/theme-parks/universal-studios-florida?utm_source=google&utm_medium=organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=17980015666189870497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "universal-studios-florida",
      "poi_latitude": "28.4793754",
      "poi_longitude": "-81.4685422",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 407-363-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdd8VlMN-54gRoaU0d_zYhfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_54d6a304b32e2ff2b5a8383f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Universal Islands of Adventure",
      "poi_type": "Entertainment",
      "poi_address": "6000 Universal Blvd, Orlando, FL 32819, USA",
      "poi_short_description": "Extreme thrill rides & the Wizarding World of Harry Potter attract crowds to this Universal park.",
      "poi_long_description": "Extreme thrill rides & the Wizarding World of Harry Potter attract crowds to this Universal park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-4299-7244-a23e-4c1056b42490.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c5-4299-7244-a23e-4c1056b42490",
        "storage_key": "property/5690533913559040/019de3c5-4299-7244-a23e-4c1056b42490.webp",
        "width": 600,
        "height": 416
      },
      "poi_business_url": "https://www.universalorlando.com/web/en/us/theme-parks/islands-of-adventure",
      "poi_directions_map_url": "https://maps.google.com/?cid=1397247755829479923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "universal-islands-of-adventure",
      "poi_latitude": "28.4716879",
      "poi_longitude": "-81.4701971",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-363-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRBCrN9-54gR84ltVW4FZBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_dcfd5d503ca3eed43d3c7ec3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "The Orlando Eye",
      "poi_type": "Entertainment",
      "poi_address": "8387 International Dr, Orlando, FL 32819, USA",
      "poi_short_description": "400-foot tall observation wheel featuring enclosed, air-conditioned glass capsules & sweeping views.",
      "poi_long_description": "400-foot tall observation wheel featuring enclosed, air-conditioned glass capsules & sweeping views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-ce36-71fc-a2b0-9b60a4cb60d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-ce36-71fc-a2b0-9b60a4cb60d7",
        "storage_key": "property/5690533913559040/019de3c7-ce36-71fc-a2b0-9b60a4cb60d7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.theorlandoeye.com/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=11027743864442653732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-orlando-eye",
      "poi_latitude": "28.4432628",
      "poi_longitude": "-81.4683208",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 321-209-9679",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU7bqHVV-54gRJAwZAp5qCpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferris_wheel"
    },
    {
      "id": "ec_bb64eca15e202b051349f610",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "SEA LIFE Orlando Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "8449 International Dr, Orlando, FL 32819, USA",
      "poi_short_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_long_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-cc1e-76b3-9b37-fb521769c50b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-cc1e-76b3-9b37-fb521769c50b",
        "storage_key": "property/5690533913559040/019f194a-cc1e-76b3-9b37-fb521769c50b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.visitsealife.com/orlando/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=4401759202367263371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-orlando-aquarium",
      "poi_latitude": "28.4425885",
      "poi_longitude": "-81.46856799999999",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 855-450-0680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmy7U4VJ-54gRi1LoS6wwFj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_52e7d4aab65163e1797d0c00",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Madame Tussauds Orlando",
      "poi_type": "Entertainment",
      "poi_address": "8387 International Dr, Orlando, FL 32819, USA",
      "poi_short_description": "Museum chain for life-size wax replicas of famous Americans & historic icons in themed galleries.",
      "poi_long_description": "Museum chain for life-size wax replicas of famous Americans & historic icons in themed galleries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1518-07fa-7648-b36b-1e17d4782d50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1518-07fa-7648-b36b-1e17d4782d50",
        "storage_key": "property/5690533913559040/019f1518-07fa-7648-b36b-1e17d4782d50.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.madametussauds.com/orlando/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=2734055134622557364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madame-tussauds-orlando",
      "poi_latitude": "28.4437626",
      "poi_longitude": "-81.4686057",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 855-450-0581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-1TQ1N-54gRtKSCx6hQ8SU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "ec_e14a8c024104a986d9d06a17",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "WonderWorks Orlando",
      "poi_type": "Entertainment",
      "poi_address": "9067 International Dr, Orlando, FL 32819, USA",
      "poi_short_description": "Attraction with 100+ hands-on science exhibits plus laser tag, a ropes course & a 6D motion ride.",
      "poi_long_description": "Attraction with 100+ hands-on science exhibits plus laser tag, a ropes course & a 6D motion ride.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-ce40-72e8-8a20-a2415022b22c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-ce40-72e8-8a20-a2415022b22c",
        "storage_key": "property/5690533913559040/019de3c7-ce40-72e8-8a20-a2415022b22c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wonderworksorlando.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5666914842869889574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wonderworks-orlando",
      "poi_latitude": "28.433743",
      "poi_longitude": "-81.4715282",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 407-351-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRdxzRk1-54gRJvqlZQbtpE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_bde91d5f03d0ae9883f6392e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Regal Pointe Orlando",
      "poi_type": "Entertainment",
      "poi_address": "9101 International Dr Ste 2100, Orlando, FL 32819, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-cdd9-775f-940d-3e77853d68c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-cdd9-775f-940d-3e77853d68c1",
        "storage_key": "property/5690533913559040/019de3c7-cdd9-775f-940d-3e77853d68c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-pointe-orlando-1938?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5267198632225196026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-pointe-orlando",
      "poi_latitude": "28.432394",
      "poi_longitude": "-81.46967",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fbde-77af-9df2-f0ad51b5bf38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fbde-77af-9df2-f0ad51b5bf38",
        "storage_key": "property/5690533913559040/019de3c7-fbde-77af-9df2-f0ad51b5bf38.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJAZydBUt-54gR-sc0yz_ZGEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_3ef97264121935286cc4dbcc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Dezerland Park Orlando",
      "poi_type": "Entertainment",
      "poi_address": "5250 International Dr, Orlando, FL 32819, USA",
      "poi_short_description": "Indoor recreation center with a bowling alley, glow-in-the-dark minigolf & go-karts, plus a cinema.",
      "poi_long_description": "Indoor recreation center with a bowling alley, glow-in-the-dark minigolf & go-karts, plus a cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-ccf2-7649-8ab0-f6afcf942592.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-ccf2-7649-8ab0-f6afcf942592",
        "storage_key": "property/5690533913559040/019f194a-ccf2-7649-8ab0-f6afcf942592.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dezerlandpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3108592586038061048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dezerland-park-orlando",
      "poi_latitude": "28.4685492",
      "poi_longitude": "-81.44822719999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 321-754-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX6ew05_54gR-Cc2qnzwIys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_29ed57aadc3f402da602a2e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Enzian Theater",
      "poi_type": "Entertainment",
      "poi_address": "1300 S Orlando Ave, Maitland, FL 32751, USA",
      "poi_short_description": "Nonprofit indie theater for cult & matinee classics, plus special events & a bar amid towering oaks.",
      "poi_long_description": "Nonprofit indie theater for cult & matinee classics, plus special events & a bar amid towering oaks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-ce07-7088-aaa4-19c62f1bbbf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-ce07-7088-aaa4-19c62f1bbbf9",
        "storage_key": "property/5690533913559040/019f194a-ce07-7088-aaa4-19c62f1bbbf9.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://enzian.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6818751612280462564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enzian-theater",
      "poi_latitude": "28.6164719",
      "poi_longitude": "-81.3644008",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 407-629-0054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fbde-77af-9df2-f0ad51b5bf38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fbde-77af-9df2-f0ad51b5bf38",
        "storage_key": "property/5690533913559040/019de3c7-fbde-77af-9df2-f0ad51b5bf38.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-WLCqkdw54gR5FyZzXYSoV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_78f52c5dbe2ac14eec6c2f18",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "AdventHealth Millenia ER",
      "poi_type": "Health and Wellness",
      "poi_address": "4633 Vineland Rd, Orlando, FL 32811, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-cc23-7209-939b-5d32d8b483c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-cc23-7209-939b-5d32d8b483c5",
        "storage_key": "property/5690533913559040/019f194a-cc23-7209-939b-5d32d8b483c5.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "http://www.adventhealthmillenia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14268321941868436193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-millenia-er",
      "poi_latitude": "28.4952687",
      "poi_longitude": "-81.43347370000001",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 407-727-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-x2qxB_54gR4dr6lTVDA8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_7c00b7d3186116da8982f851",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "CareSpot Urgent Care of Orlando Metro West",
      "poi_type": "Health and Wellness",
      "poi_address": "2555 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-d79c-77d8-a4e2-23d682e986ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-d79c-77d8-a4e2-23d682e986ca",
        "storage_key": "property/5690533913559040/019de3c7-d79c-77d8-a4e2-23d682e986ca.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.carespot.com/carespot-urgent-care/metro-west-orlando-fl/?utm_source=google&utm_medium=organic&utm_content=metro-west-orlando&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1197448886656857757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carespot-urgent-care-of-orlando-metro-west",
      "poi_latitude": "28.5154269",
      "poi_longitude": "-81.45829789999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-362-2030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg27fgDx554gRnXbeBWsxnhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_b68cecd8ab04ce240abae06a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "MD Now Urgent Care - West Orlando",
      "poi_type": "Health and Wellness",
      "poi_address": "2438 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-d6bc-70b6-ba27-b70cd9cbda1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-d6bc-70b6-ba27-b70cd9cbda1a",
        "storage_key": "property/5690533913559040/019de3c7-d6bc-70b6-ba27-b70cd9cbda1a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mymdnow.com/locations/orlando/west-orlando?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3856616519002022192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "md-now-urgent-care---west-orlando",
      "poi_latitude": "28.515889",
      "poi_longitude": "-81.4599499",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 321-335-4336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwYG5kXeH3YgRMOEEckp0hTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_346bbe6682d55ff361b0b5fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2500 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-d5fd-7535-b9dc-e8791ee17e83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-d5fd-7535-b9dc-e8791ee17e83",
        "storage_key": "property/5690533913559040/019de3c7-d5fd-7535-b9dc-e8791ee17e83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/1220-orlando-fl/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8833956871437807206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "28.5154993",
      "poi_longitude": "-81.46274369999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-297-9785",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fbd7-7598-8ec9-1c941a3047b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fbd7-7598-8ec9-1c941a3047b4",
        "storage_key": "property/5690533913559040/019de3c7-fbd7-7598-8ec9-1c941a3047b4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ68somTx554gRZu4rY_iEmHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_3a1b0e759aa8ab2fd2c859ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "920 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-c460-741b-8986-e05cf9af265a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-c460-741b-8986-e05cf9af265a",
        "storage_key": "property/5690533913559040/019de3c7-c460-741b-8986-e05cf9af265a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-920+s+kirkman+rd-orlando-fl-32811/id=6505",
      "poi_directions_map_url": "https://maps.google.com/?cid=504296818139990830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "28.5285182",
      "poi_longitude": "-81.46008739999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-253-6288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fbd7-7598-8ec9-1c941a3047b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fbd7-7598-8ec9-1c941a3047b4",
        "storage_key": "property/5690533913559040/019de3c7-fbd7-7598-8ec9-1c941a3047b4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVFlxB554gRLguYwkif_wY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_6d73a70013c934b653802199",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Crunch Fitness - Kirkman",
      "poi_type": "Health and Wellness",
      "poi_address": "1101 Resource Ave, Orlando, FL 32835, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-78da-77bd-a7b3-a113d1514dab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c5-78da-77bd-a7b3-a113d1514dab",
        "storage_key": "property/5690533913559040/019de3c5-78da-77bd-a7b3-a113d1514dab.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.crunch.com/locations/kirkman",
      "poi_directions_map_url": "https://maps.google.com/?cid=690306131854013851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---kirkman",
      "poi_latitude": "28.526755",
      "poi_longitude": "-81.4617999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 321-445-0296",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWXcGwT9554gRm7Vu_8R1lAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_314c2b9d024bc42dfa886922",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4792 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Relaxed gym featuring a sauna, a pool, and basketball courts, plus clean facilities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-7c73-741f-a907-5ac4b5962a59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c5-7c73-741f-a907-5ac4b5962a59",
        "storage_key": "property/5690533913559040/019de3c5-7c73-741f-a907-5ac4b5962a59.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1058&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1227584321160174495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "28.4922898",
      "poi_longitude": "-81.4605285",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-362-0645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN3Sz5M1-54gRn1uXom9BCRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_354f5eb78801436702936786",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5920 Metropolis Wy, Orlando, FL 32811, USA",
      "poi_short_description": "Clean gym featuring equipment such as treadmills and tanning beds, plus showers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-78de-76bd-b5da-7c145f369d4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c5-78de-76bd-b5da-7c145f369d4a",
        "storage_key": "property/5690533913559040/019de3c5-78de-76bd-b5da-7c145f369d4a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/orlando-metro-west-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10090887386500861907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "28.5172728",
      "poi_longitude": "-81.4615642",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-722-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-WddmDx554gR04_aPJ0ICow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_6ea7bad69c0a2ec26fed80b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "DR Pilates Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "775 S Kirkman Rd Ste 107, Orlando, FL 32811, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1518-0c46-7508-a95e-6d1400b65c23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1518-0c46-7508-a95e-6d1400b65c23",
        "storage_key": "property/5690533913559040/019f1518-0c46-7508-a95e-6d1400b65c23.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.instagram.com/drpilatesorlando/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6061942479823438396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dr-pilates-studio",
      "poi_latitude": "28.5330877",
      "poi_longitude": "-81.458153",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 689-267-1034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a912-74dd-97dc-736721bea8fb",
        "storage_key": "property/5690533913559040/019de3c5-a912-74dd-97dc-736721bea8fb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTeSvi9t554gRPAK6XpFYIFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_8feedab5db5fa6292ef3cd21",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "The Fitness Studio of Orlando",
      "poi_type": "Health and Wellness",
      "poi_address": "6700 Conroy Rd, Orlando, FL 32835, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-d5e0-7764-a164-a1443b4c6192.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-d5e0-7764-a164-a1443b4c6192",
        "storage_key": "property/5690533913559040/019f194a-d5e0-7764-a164-a1443b4c6192.webp",
        "width": 1155,
        "height": 974
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7522980903226890453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-fitness-studio-of-orlando",
      "poi_latitude": "28.4928722",
      "poi_longitude": "-81.47380919999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-532-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC-8DKyp_54gR1dji5EX_Zmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_3df017c98cc7280f3b69ec8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Eagle Nest Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5165 Metrowest Blvd, Orlando, FL 32811, USA",
      "poi_short_description": "Outdoor park providing paved walking trails, softball fields, picnic pavilions & eagle sightings.",
      "poi_long_description": "Outdoor park providing paved walking trails, softball fields, picnic pavilions & eagle sightings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1518-0e47-7168-a018-5ca31561a7b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1518-0e47-7168-a018-5ca31561a7b2",
        "storage_key": "property/5690533913559040/019f1518-0e47-7168-a018-5ca31561a7b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orlando.gov/Parks-the-Environment/Directory/Eagle-Nest-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13987987886153007420&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eagle-nest-park",
      "poi_latitude": "28.5170791",
      "poi_longitude": "-81.449704",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-246-2283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-9071bc5d8b74",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV2x33j5554gRPAGe9N5QH8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2988b51afd77ed52b73ffffa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Barnett Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4801 W Colonial Dr, Orlando, FL 32808, USA",
      "poi_short_description": "Park with trails, disc golf, playgrounds, fitness classes, plus basketball & volleyball courts.",
      "poi_long_description": "Park with trails, disc golf, playgrounds, fitness classes, plus basketball & volleyball courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-9cc9-74da-9e97-453748e24069.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c5-9cc9-74da-9e97-453748e24069",
        "storage_key": "property/5690533913559040/019de3c5-9cc9-74da-9e97-453748e24069.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orangecountyfl.net/cultureparks/parks.aspx?m=dtlvw&d=3",
      "poi_directions_map_url": "https://maps.google.com/?cid=15001828583162330551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barnett-park",
      "poi_latitude": "28.5606872",
      "poi_longitude": "-81.443101",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 407-836-6248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-9071bc5d8b74",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ27CA7Zp554gRtz2xAJ0zMdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d8d4e3409f1599380ef8ba65",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Bill Frederick Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3401 S Hiawassee Rd, Orlando, FL 32835, USA",
      "poi_short_description": "This 183-acre park on Turkey Lake offers fishing, boating & a playground, plus cabin & tent camping.",
      "poi_long_description": "This 183-acre park on Turkey Lake offers fishing, boating & a playground, plus cabin & tent camping.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-9c67-776c-ac1c-d2591e656785.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c5-9c67-776c-ac1c-d2591e656785",
        "storage_key": "property/5690533913559040/019de3c5-9c67-776c-ac1c-d2591e656785.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityoforlando.net/parks/bill-frederick-park-turkey-lake/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3622395875443829037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-frederick-park",
      "poi_latitude": "28.5071117",
      "poi_longitude": "-81.48389829999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-246-4486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-9071bc5d8b74",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRQu2NN454gRLWmrP9tVRTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5f3588db102991239af4ef17",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Shadow Bay Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5100 Turkey Lake Rd, Orlando, FL 32819, USA",
      "poi_short_description": "This scenic park provides hiking/biking trails, wildlife, sand dunes & a full-service tennis center.",
      "poi_long_description": "This scenic park provides hiking/biking trails, wildlife, sand dunes & a full-service tennis center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1518-1300-702b-a02a-b3793a68ea8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1518-1300-702b-a02a-b3793a68ea8f",
        "storage_key": "property/5690533913559040/019f1518-1300-702b-a02a-b3793a68ea8f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.orangecountyfl.net/CultureParks/Parks.aspx?m=dtlvw&d=36#.WOYyufnyvRY",
      "poi_directions_map_url": "https://maps.google.com/?cid=14806647333848639398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shadow-bay-park",
      "poi_latitude": "28.4919365",
      "poi_longitude": "-81.478537",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-254-9175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-9071bc5d8b74",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJaW9o8ih_54gRpmeIGE3He80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_44bb039cbf5b62dd74519baa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "MetroWest Golf Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2100 S Hiawassee Rd, Orlando, FL 32835, USA",
      "poi_short_description": "Club featuring an 18-hole public golf course, plus restaurants, a pro shop & lessons.",
      "poi_long_description": "Club featuring an 18-hole public golf course, plus restaurants, a pro shop & lessons.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-df6f-73be-950d-3b70ebfe9a1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-df6f-73be-950d-3b70ebfe9a1e",
        "storage_key": "property/5690533913559040/019de3c7-df6f-73be-950d-3b70ebfe9a1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.metrowestgolf.com/?utm_source=GMB&utm_medium=organic&utm_campaign=LocalSearch",
      "poi_directions_map_url": "https://maps.google.com/?cid=17004541885259092582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metrowest-golf-club",
      "poi_latitude": "28.5208851",
      "poi_longitude": "-81.4777659",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-299-1099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQbAcKth454gRZpIeL8BE_Os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "ec_bc22e1a0fb01306635e585a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Orlo Vista Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 N Powers Dr, Orlando, FL 32835, USA",
      "poi_short_description": "Basketball ground and playground near a serene lake for family-friendly fun.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-e010-733c-99f8-7409c6a38147.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-e010-733c-99f8-7409c6a38147",
        "storage_key": "property/5690533913559040/019de3c7-e010-733c-99f8-7409c6a38147.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.orangecountyfl.net/CultureParks/Parks.aspx?m=dtlvw&d=31#.Vli_sYF97lN",
      "poi_directions_map_url": "https://maps.google.com/?cid=6354106650712229735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlo-vista-park",
      "poi_latitude": "28.5420476",
      "poi_longitude": "-81.46625949999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-254-9050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-9071bc5d8b74",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ48QkJQd554gRZ0emVFVSLlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_638c6e023b20d436271fce64",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Ivey Lane Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "291 Silverton St #1745, Orlando, FL 32811, USA",
      "poi_short_description": "Recreation center with picnic tables that's good for kids.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1518-0ea5-70cc-b027-5683acc41e81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1518-0ea5-70cc-b027-5683acc41e81",
        "storage_key": "property/5690533913559040/019f1518-0ea5-70cc-b027-5683acc41e81.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cityoforlando.net/recreation/ivey-lane-neighborhood-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13659191138156185132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ivey-lane-park",
      "poi_latitude": "28.5452447",
      "poi_longitude": "-81.43808709999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-246-4457",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-9071bc5d8b74",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0bfz0IJ554gRLIb2fPgxj70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_52924cc389994c8dc1f70482",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Lake Davis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "723 S Lake Davis Dr, Orlando, FL 32806, USA",
      "poi_short_description": "Lake and wildlife park featuring bird life, swans and ducks, plus a walking path.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-d7eb-7013-8f96-6e2c9419a3f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-d7eb-7013-8f96-6e2c9419a3f6",
        "storage_key": "property/5690533913559040/019f194a-d7eb-7013-8f96-6e2c9419a3f6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.orlando.gov/Parks-the-Environment/Directory/Lake-Davis-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12149407079244166527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-davis-park",
      "poi_latitude": "28.5329655",
      "poi_longitude": "-81.3665295",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-246-2283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-9071bc5d8b74",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-9071bc5d8b74.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzXg3Wxl754gRf_X2RV5dm6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4c26bc5f8985adc677ce2521",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "S Kirkman Rd & Metrowest Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Orlando, FL 32811, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-e600-72c4-b71f-dc1bfe9ead76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-e600-72c4-b71f-dc1bfe9ead76",
        "storage_key": "property/5690533913559040/019de3c7-e600-72c4-b71f-dc1bfe9ead76.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4780843389778251080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "s-kirkman-rd--metrowest-blvd",
      "poi_latitude": "28.512786",
      "poi_longitude": "-81.45931399999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhc9SGDt554gRSM2Bprv3WEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_11a0e467075e69f300ee669c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "MetroWest Blvd and Metro Park Cir",
      "poi_type": "Transportation & Transit",
      "poi_address": "Orlando, FL 32835, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4963260983622856789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metrowest-blvd-and-metro-park-cir",
      "poi_latitude": "28.5149155",
      "poi_longitude": "-81.46655299999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7QSNqCZ554gRVXBlcJEL4UQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_151233498d46dfd7ac351b4f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "N Kirkman Rd & State Rd 408 Off Ramp E",
      "poi_type": "Transportation & Transit",
      "poi_address": "Orlovista, FL 32835, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17681349085241841601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "n-kirkman-rd--state-rd-408-off-ramp-e",
      "poi_latitude": "28.547168",
      "poi_longitude": "-81.45794099999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6Ug_6Z554gRwZeEL1DFYPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_19fc59b3dea0d5891b35cf79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Sand Lake Sun Rail",
      "poi_type": "Transportation & Transit",
      "poi_address": "8030 S Orange Ave, Pine Castle, FL 32809, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-e90c-70f2-86fd-04b53abed74f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-e90c-70f2-86fd-04b53abed74f",
        "storage_key": "property/5690533913559040/019de3c7-e90c-70f2-86fd-04b53abed74f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12732818489700762014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sand-lake-sun-rail",
      "poi_latitude": "28.4532532",
      "poi_longitude": "-81.3667215",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJObExjOZ854gRnsEjfPQOtLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_af97fea5f9bd78e044dfcbde",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Lynx Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "455 N Garland Ave, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-e973-709e-9a5a-c69b819f9c71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-e973-709e-9a5a-c69b819f9c71",
        "storage_key": "property/5690533913559040/019de3c7-e973-709e-9a5a-c69b819f9c71.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.golynx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5762862083644479993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lynx-central",
      "poi_latitude": "28.548485",
      "poi_longitude": "-81.381256",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 407-841-5969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fc09-7665-b6e4-45b56ac0e852.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fc09-7665-b6e4-45b56ac0e852",
        "storage_key": "property/5690533913559040/019de3c7-fc09-7665-b6e4-45b56ac0e852.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ZcEsvl654gR-VkyOYjM-U8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_f616ae1e420f86b963949969",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Orlando Executive Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "365 Rickenbacker Dr, Orlando, FL 32803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-d768-7228-be1e-f68abcb3b6ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-d768-7228-be1e-f68abcb3b6ba",
        "storage_key": "property/5690533913559040/019f194a-d768-7228-be1e-f68abcb3b6ba.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://flymco.com/orlando-executive-airport/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8563532095212316047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-executive-airport",
      "poi_latitude": "28.5487931",
      "poi_longitude": "-81.3322156",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 407-825-1699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fc09-7665-b6e4-40ad35f2de27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fc09-7665-b6e4-40ad35f2de27",
        "storage_key": "property/5690533913559040/019de3c7-fc09-7665-b6e4-40ad35f2de27.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3IVTy5l54gRj2XJrRHH13Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_416dbd39f75a3c2a73e3ca14",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Orlando International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Jeff Fuqua Blvd, Orlando, FL 32827, USA",
      "poi_short_description": "High-traffic airport with a hub-&-spoke design features an on-site hotel & lots of public artwork.",
      "poi_long_description": "High-traffic airport with a hub-&-spoke design features an on-site hotel & lots of public artwork.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-ecb7-7078-8597-2e16655405ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-ecb7-7078-8597-2e16655405ec",
        "storage_key": "property/5690533913559040/019de3c7-ecb7-7078-8597-2e16655405ec.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://flymco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12486996560901693805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-international-airport",
      "poi_latitude": "28.4244422",
      "poi_longitude": "-81.3104595",
      "poi_miles_from_property": "20.1 mi",
      "poi_walking_minutes": "7 hours 24 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 407-825-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-fc09-7665-b6e4-40ad35f2de27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c7-fc09-7665-b6e4-40ad35f2de27",
        "storage_key": "property/5690533913559040/019de3c7-fc09-7665-b6e4-40ad35f2de27.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85K0xidj54gRbeERlDa5Sq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_b40ae2b1c37d1823c7092ffe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Orlando Health Dr. P. Phillips Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "9400 Turkey Lake Rd, Orlando, FL 32819, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-ed62-77c0-b517-e1b0eff121f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-ed62-77c0-b517-e1b0eff121f3",
        "storage_key": "property/5690533913559040/019de3c7-ed62-77c0-b517-e1b0eff121f3.webp",
        "width": 1170,
        "height": 1158
      },
      "poi_business_url": "https://www.orlandohealth.com/facilities/dr-p-phillips-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=17782854594798866852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-health-dr-p-phillips-hospital",
      "poi_latitude": "28.4291825",
      "poi_longitude": "-81.4785341",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 407-351-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e4654613e70b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e4654613e70b",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e4654613e70b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7em3_Ml_54gRpNFoTwlkyfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_430291e8adef70948ae6fd11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Orlando Lockheed Martin MFC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5600 W Sand Lake Rd, Orlando, FL 32819, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lockheedmartin.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9805895731295754660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-lockheed-martin-mfc",
      "poi_latitude": "28.4425328",
      "poi_longitude": "-81.4612516",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNezeJFp-54gRpBlnuDaKFYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_5b50d4eca5aec154b6ee1fe6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Golf Now Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7580 Golf Channel Dr, Orlando, FL 32819, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-d89f-71de-a987-417481ce767f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-d89f-71de-a987-417481ce767f",
        "storage_key": "property/5690533913559040/019f194a-d89f-71de-a987-417481ce767f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nbcsports.com/golf",
      "poi_directions_map_url": "https://maps.google.com/?cid=17860508883824079552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golf-now-corporate",
      "poi_latitude": "28.4532924",
      "poi_longitude": "-81.4534372",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJocRasPV-54gRwPIKaDNG3fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_4f11d253dd91527dfbc87aa8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Universal Orlando Resort",
      "poi_type": "Entertainment",
      "poi_address": "6000 Universal Blvd, Orlando, FL 32819, USA",
      "poi_short_description": "Large, well-known theme park featuring movie-themed rides & shows, plus hotels & restaurants.",
      "poi_long_description": "Large, well-known theme park featuring movie-themed rides & shows, plus hotels & restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f1518-0281-76cb-86ae-899297cd344c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1518-0281-76cb-86ae-899297cd344c",
        "storage_key": "property/5690533913559040/019f1518-0281-76cb-86ae-899297cd344c.webp",
        "width": 1280,
        "height": 901
      },
      "poi_business_url": "https://www.universalorlando.com/web/en/us",
      "poi_directions_map_url": "https://maps.google.com/?cid=120970616096332569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "universal-orlando-resort",
      "poi_latitude": "28.4723529",
      "poi_longitude": "-81.4690029",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-363-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8f0-72dd-a335-95935b98b023",
        "storage_key": "property/5690533913559040/019de3c5-a8f0-72dd-a335-95935b98b023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRBCrN9-54gRGZuuaCLGrQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_e5ae531c931bc2a8b3c22543",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "AdventHealth Orlando",
      "poi_type": "Health and Wellness",
      "poi_address": "601 E Rollins St, Orlando, FL 32803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-eef5-7140-9860-2ea6bd16d774.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-eef5-7140-9860-2ea6bd16d774",
        "storage_key": "property/5690533913559040/019de3c7-eef5-7140-9860-2ea6bd16d774.webp",
        "width": 1125,
        "height": 852
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-orlando",
      "poi_directions_map_url": "https://maps.google.com/?cid=2606235450744802745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-orlando",
      "poi_latitude": "28.5751245",
      "poi_longitude": "-81.3696726",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 407-303-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e4654613e70b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e4654613e70b",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e4654613e70b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkezOtZt654gRuY2sglU1KyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_6516306948ad62696d985ef7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Orlando Health Orlando Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "52 W Underwood St, Orlando, FL 32806, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-7e02-773d-a6f7-74d2a77baf30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c5-7e02-773d-a6f7-74d2a77baf30",
        "storage_key": "property/5690533913559040/019de3c5-7e02-773d-a6f7-74d2a77baf30.webp",
        "width": 1280,
        "height": 935
      },
      "poi_business_url": "https://www.orlandohealth.com/facilities/orlando-regional-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=24878703848122848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-health-orlando-regional-medical-center",
      "poi_latitude": "28.526485",
      "poi_longitude": "-81.3778912",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 321-841-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e4654613e70b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e4654613e70b",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e4654613e70b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9TcQw9754gR4OlWoQxjWAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_00bc6465192b98a14f3e5f59",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Nemours Children's Hospital, Florida",
      "poi_type": "Health and Wellness",
      "poi_address": "6535 Nemours Pkwy, Orlando, FL 32827, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c7-f14f-75cb-91d8-fc872ebaa4b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019de3c7-f14f-75cb-91d8-fc872ebaa4b8",
        "storage_key": "property/5690533913559040/019de3c7-f14f-75cb-91d8-fc872ebaa4b8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.nemours.org/locations/orlando-nemours-childrens-hospital.html?utm_source=GMB&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=74781518432658109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nemours-childrens-hospital-florida",
      "poi_latitude": "28.3764823",
      "poi_longitude": "-81.2724191",
      "poi_miles_from_property": "20.6 mi",
      "poi_walking_minutes": "7 hours 34 mins",
      "poi_biking_minutes": "2 hours 4 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 407-567-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c5-a8ef-7329-a339-e4654613e70b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019de3c5-a8ef-7329-a339-e4654613e70b",
        "storage_key": "property/5690533913559040/019de3c5-a8ef-7329-a339-e4654613e70b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Uv5wumJ3YgRvWLxEWWtCQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_66c813d754629759fac0ec13",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "poi_name": "Orange County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "425 N Orange Ave, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-d896-71e9-8db5-bf6cbaf668c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f194a-d896-71e9-8db5-bf6cbaf668c8",
        "storage_key": "property/5690533913559040/019f194a-d896-71e9-8db5-bf6cbaf668c8.webp",
        "width": 953,
        "height": 1280
      },
      "poi_business_url": "http://www.ninthcircuit.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17373259777413094356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orange-county-courthouse",
      "poi_latitude": "28.5482276",
      "poi_longitude": "-81.37783379999999",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 407-836-2050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f194a-dfab-7799-bb12-2797b39be848.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f194a-dfab-7799-bb12-2797b39be848",
        "storage_key": "property/5690533913559040/019f194a-dfab-7799-bb12-2797b39be848.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS9xskYN754gR1BtKV7g3GvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_8fc054fefb7645f10b29ffee",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0443133bc921b04fea0df9fc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_51d4f8ae1bf3d3268112c96c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6d2cda5601b22b28db41b7dd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d134b7f11edf46287ac053b3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_09070c0f9702b740805e5777",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_5e12f063539521ea4cabbcea",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "rating": "5",
      "name": "Jose Manuel Gracia Arana",
      "text": "From the very beginning of the rental process, everything was smooth, transparent, and very accessible. I would like to give special recognition to Isabella Colmenares, who guided us through every step with professionalism, patience, and kindness until we were finally able to move in. I would also like to highlight David, one of the maintenance team members, who handled one of our service requests promptly, efficiently, and with great courtesy. Overall, we are very happy with our experience and truly pleased with the place. Thank you for providing such excellent service.",
      "date": "2026-03-10",
      "title": "false"
    },
    {
      "id": "ec_0ea6f83df96f81b8674ea597",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "rating": "5",
      "name": "andrea hernandez",
      "text": "Amazing apartment complex! The leasing office is very responsible and always helpful with residents. Everything is clean and well maintained, and the security is great. The office team truly cares about the community and goes above and beyond to help. One of the best properties I’ve experienced. Highly recommend!",
      "date": "2026-01-13",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_20c1299e5e525a6560ad40ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c6-0860-75ea-8130-666b7f2f71c7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019de3c6-0860-75ea-8130-666b7f2f71c7",
        "storage_key": "property/5690533913559040/019de3c6-0860-75ea-8130-666b7f2f71c7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1015SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=o2ejGQaFYkX"
    },
    {
      "id": "ec_f8a67cb79b126bed187d00d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c6-0957-733d-8265-640c33be1206.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019de3c6-0957-733d-8265-640c33be1206",
        "storage_key": "property/5690533913559040/019de3c6-0957-733d-8265-640c33be1206.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UV1cMM2K1Tk"
    },
    {
      "id": "ec_372d4b7b119dff8dd7ff058d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019de3c6-08b9-7567-b517-838b667cbc6a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019de3c6-08b9-7567-b517-838b667cbc6a",
        "storage_key": "property/5690533913559040/019de3c6-08b9-7567-b517-838b667cbc6a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DCkTrAJhJtx"
    }
  ],
  "faqs": [
    {
      "id": "custom_91680073-cf50-46fb-8f2f-1eb0b2d6e3e6",
      "question": "Is 1801 Metrowest pet-friendly?",
      "answer": "Yes, 1801 Metrowest is a pet-friendly community. We happily accept up to 2 pets per apartment home. Breed restrictions apply. Please check with us if you have questions regarding our restricted breed list, and we look forward to welcoming both you and your pets to our community. Cats and dogs allowed, up to 2 per home with no weight limit. For full pet details, please contact our leasing office or call (407) 293-3355.",
      "category": "Pets",
      "source": "custom"
    },
    {
      "id": "custom_3cae94c9-d42b-49fc-91dd-30ac395a5c5d",
      "question": "How can I schedule a tour at 1801 Metrowest?",
      "answer": "Scheduling a tour at 1801 Metrowest is easy. Visit our Schedule a Tour page to pick a time that works for you, or call our leasing office at (407) 293-3355. We offer in-person tours, self-guided tours, and virtual tour options.",
      "category": "Tours & Leasing Office",
      "source": "custom"
    },
    {
      "id": "custom_829a77f8-957d-43fb-8a1c-398fb1a7b574",
      "question": "What are the leasing office hours at 1801 Metrowest?",
      "answer": "Our leasing office hours are:\nMonday: 9:00 AM – 6:00 PM\nTuesday: 9:00 AM – 6:00 PM\nWednesday: 9:00 AM – 6:00 PM\nThursday: 9:00 AM – 6:00 PM\nFriday: 9:00 AM – 6:00 PM\nSaturday: 10:00 AM – 5:00 PM. For the most current hours or to confirm availability, contact us or call (407) 293-3355.",
      "category": "Tours & Leasing Office",
      "source": "custom"
    },
    {
      "id": "custom_5f96cb47-8f2c-4b4b-8cfa-7e0226a80b30",
      "question": "What floor plans are available at 1801 Metrowest?",
      "answer": "1801 Metrowest offers a variety of thoughtfully designed floor plans, including 1-bedroom, 2-bedroom apartments ranging from 723 - 1015 square feet. Browse availability, layouts, and details on our Floor Plans page, or contact our leasing team for personalized recommendations.",
      "category": "Floor Plans",
      "source": "custom"
    },
    {
      "id": "custom_3903fe94-9334-4df0-a797-ade92abd6294",
      "question": "What amenities does 1801 Metrowest have?",
      "answer": "1801 Metrowest features a curated set of community and apartment amenities designed for comfort and convenience. Community highlights include Business Center, Clubhouse, Picnic Area, Fitness Center, Pool, Tennis Court, American Landmark 360 Resident Program, Bark Park for Furry Friends. In-home features include Air Conditioning, Fireplace, Washer/Dryer, Stainless Steel Appliances, Walk-In Closets, Balcony. See the full list on our Amenities page.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_8fdaf87c-423f-4013-865b-af42ee570fe0",
      "question": "Where is 1801 Metrowest located?",
      "answer": "1801 Metrowest is located at 1801 S Kirkman Rd, Orlando, FL 32811. Explore the surrounding area and nearby points of interest on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_d1d03833-52fe-4b51-8a34-26928ac208e2",
      "question": "How do I apply to live at 1801 Metrowest?",
      "answer": "You can apply to live at 1801 Metrowest online through our Apply Now page. The process takes just a few minutes — simply select your preferred floor plan, complete the rental application, and submit any required documents. If you have questions during the process, call us at (407) 293-3355 or contact our leasing office.",
      "category": "Application & Leasing",
      "source": "custom"
    },
    {
      "id": "custom_3a2e1317-989c-4ee8-b751-2e20ca08094b",
      "question": "What do I need to apply at 1801 Metrowest?",
      "answer": "To apply at 1801 Metrowest, you'll typically need a valid government-issued photo ID, proof of income (such as recent pay stubs or an offer letter), and the application fee. Most applicants must meet standard income and credit requirements. For the full list of application requirements, visit our Apply Now page or contact our leasing team.",
      "category": "Application & Leasing",
      "source": "custom"
    },
    {
      "id": "custom_af4c048e-db26-4079-88dd-091b2785ce23",
      "question": "Does 1801 Metrowest have a dog park?",
      "answer": "Yes, 1801 Metrowest features a dedicated bark park where your furry friends can play and socialize. It's one of our most popular community amenities for residents with dogs. Learn more on our Amenities page.",
      "category": "Pets",
      "source": "custom"
    },
    {
      "id": "custom_9fec4efe-b769-46db-8bdf-3ac0ad10db74",
      "question": "Does 1801 Metrowest have a pool?",
      "answer": "Yes, 1801 Metrowest features a sparkling community pool — perfect for relaxing, swimming, or soaking up the sun. Take a closer look on our Amenities page or schedule a tour to see it in person.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_18de839e-3784-4d43-8169-0659122b169c",
      "question": "Does 1801 Metrowest have a fitness center?",
      "answer": "Yes, 1801 Metrowest offers a fully equipped fitness center for residents — designed to support your wellness routine without leaving the community. See more on our Amenities page.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_e4bd57fd-8993-4e16-bb78-3cf1d53779c2",
      "question": "Does 1801 Metrowest offer virtual tours?",
      "answer": "Yes, 1801 Metrowest offers virtual tours so you can explore our community and apartments from anywhere. Visit our Virtual Tours page to start touring online, or schedule an in-person tour when you're ready to see it firsthand.",
      "category": "Tours & Leasing Office",
      "source": "custom"
    },
    {
      "id": "custom_848780a0-6c76-4fe1-8ac4-4ada6d13c28e",
      "question": "What schools are near 1801 Metrowest?",
      "answer": "1801 Metrowest is located near several schools, including Valencia College West Campus, Eagle's Nest Elementary School, Dr. Phillips High School, MetroWest Elementary School. Explore more nearby schools and amenities on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_4aa8b4c9-c2db-4cf5-ae46-aff170ea4461",
      "question": "What do residents say about living at 1801 Metrowest?",
      "answer": "Residents at 1801 Metrowest consistently highlight our friendly staff, responsive maintenance team, well-maintained amenities, and welcoming community atmosphere. You can read full resident reviews on our Reviews page.",
      "category": "Resident Life & Programs",
      "source": "custom"
    },
    {
      "id": "custom_9743a259-4d84-4ca7-9156-53d8c6c45b01",
      "question": "What's the commute like from 1801 Metrowest?",
      "answer": "1801 Metrowest offers convenient access to major roads and key destinations around Orlando. Discover commute times and nearby transit on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_21b0cb63-8627-4e0f-9249-848551790d51",
      "question": "What are the income requirements at 1801 Metrowest?",
      "answer": "Most applicants at 1801 Metrowest must demonstrate a monthly income of approximately 2.5 to 3 times the monthly rent. Specific requirements may vary by floor plan and lease term. For exact criteria, please contact our leasing office.",
      "category": "Application & Leasing",
      "source": "custom"
    },
    {
      "id": "custom_1cb3bfb1-00d1-442d-93ff-363c22bda6c9",
      "question": "Is a credit check required to apply at 1801 Metrowest?",
      "answer": "Yes, all applicants at 1801 Metrowest are subject to a credit and background check as part of our standard application process. This helps us maintain a safe, well-managed community for all residents. For questions, contact our leasing team.",
      "category": "Application & Leasing",
      "source": "custom"
    },
    {
      "id": "custom_9cd0f23f-20b8-45f9-9afa-7d77c1be10c5",
      "question": "Is there an application fee at 1801 Metrowest?",
      "answer": "Yes, there is a standard application fee at 1801 Metrowest that helps cover processing and background screening costs. The fee amount and any current promotions are listed on our Apply Now page or available by contacting our leasing office.",
      "category": "Application & Leasing",
      "source": "custom"
    },
    {
      "id": "custom_533c3fb0-2728-402c-b9e6-b2de82fbe31d",
      "question": "Does 1801 Metrowest accept co-signers or guarantors?",
      "answer": "In some cases, 1801 Metrowest may accept a qualified co-signer or guarantor for applicants who don't meet individual income or credit requirements on their own. Please contact our leasing office to discuss your specific situation.",
      "category": "Application & Leasing",
      "source": "custom"
    },
    {
      "id": "custom_395f5ad5-3774-4f6b-9fa3-e448405c0d02",
      "question": "What lease terms are available at 1801 Metrowest?",
      "answer": "1801 Metrowest offers a range of lease term options to fit different needs, with standard 12-month leases being the most common. Other lengths may be available depending on inventory. For current options, reach out to our leasing team.",
      "category": "Application & Leasing",
      "source": "custom"
    },
    {
      "id": "custom_da310b4d-b540-410b-8638-02e0f9a32164",
      "question": "Is renters insurance required at 1801 Metrowest?",
      "answer": "Yes, renters insurance is required for all residents at 1801 Metrowest. It helps protect your personal belongings and provides liability coverage. Details on coverage requirements are available by contacting our team.",
      "category": "Application & Leasing",
      "source": "custom"
    },
    {
      "id": "custom_8798d73e-28ea-4656-b0f0-c6c931cb0b63",
      "question": "What utilities are included at 1801 Metrowest?",
      "answer": "Utility responsibilities at 1801 Metrowest vary by floor plan. Most apartment homes have residents set up their own electric and other services, while some community-managed utilities may be billed separately. For a complete breakdown, please contact our leasing office.",
      "category": "Application & Leasing",
      "source": "custom"
    },
    {
      "id": "custom_3d987871-1a81-4d18-af1b-cc6ab12112ba",
      "question": "When was 1801 Metrowest built?",
      "answer": "1801 Metrowest was originally built in 1990 and underwent updates in 2021. This large-scale community continues to offer quality apartment living in Orlando. Learn more about the community on our Gallery page.",
      "category": "Property Details",
      "source": "custom"
    },
    {
      "id": "custom_83a9b66d-4233-4d8c-aa0b-001bc2c3e571",
      "question": "How many apartments are at 1801 Metrowest?",
      "answer": "1801 Metrowest is a large-scale community with approximately 300 apartment homes. This gives residents the right balance of community feel and personal privacy. Explore floor plans on our Floor Plans page.",
      "category": "Property Details",
      "source": "custom"
    },
    {
      "id": "custom_ece62ad0-d8e4-4da8-8939-30deeea991d8",
      "question": "What is the Landmark 360 program at 1801 Metrowest?",
      "answer": "The Landmark 360 Resident Program at 1801 Metrowest is American Landmark's signature commitment to resident satisfaction. It includes three promises: (1) The Move-In Satisfaction Promise — if you're not 100% satisfied within your first 15 days, we'll refund your deposit and waive termination fees. (2) The 48-Hour Maintenance Completion Promise — all standard work orders submitted Monday through Friday are completed within 48 hours, with rent credits issued for qualifying delays. (3) The Hassle-Free Relocation Promise — after six months on your lease, you can transfer to another American Landmark community without penalties by providing 60 days' written notice. Contact our leasing office for full program details.",
      "category": "Resident Life & Programs",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-134a-743e-a914-2eea16df4015",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "1801-metrowest",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040"
    },
    {
      "lead_collector_id": "0198aa45-13ac-767e-8b0a-7c9e4c1bea6a",
      "lead_source": "FACEBOOK_ADS",
      "name": "1801-metrowest",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040"
    },
    {
      "lead_collector_id": "0198aa45-140e-7380-ae7a-5747aee1fc25",
      "lead_source": "LANDING_PAGE",
      "name": "1801-metrowest",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-in-orlando-fl",
      "search_query": "One Bedroom Apartments For Rent In Orlando FL",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Orlando FL at 1801 MetroWest",
      "h2_subtitle": "Discover the perfect blend of comfort and style at 1801 MetroWest. Our one bedroom apartments for rent in Orlando FL offer remarkable features and oversized floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our one bedroom apartments for rent in Orlando FL. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy high-speed internet access, air conditioning, and walk-in closets, all designed to enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | One Bedroom Apartments For Rent In Orlando FL",
      "seo_description": "Discover comfort and style at 1801 MetroWest. Our one bedroom apartments for rent in Orlando FL feature oversized floor plans and remarkable amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-orlando-metrowest",
      "search_query": "Two Bedrooms Apartments For Rent In Orlando FL",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Orlando FL at 1801 MetroWest",
      "h2_subtitle": "Experience luxury and comfort at 1801 MetroWest. Our two bedrooms apartments for rent in Orlando FL offer spacious layouts and top-notch features.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our two bedrooms apartments for rent in Orlando FL. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy high-speed internet access, air conditioning, and walk-in closets, all designed to enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Two Bedrooms Apartments For Rent In Orlando FL",
      "seo_description": "Experience luxury at 1801 MetroWest. Our two bedrooms apartments for rent in Orlando FL feature spacious layouts and top-notch amenities for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-pool-at-metrowest",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Pool at 1801 MetroWest",
      "h2_subtitle": "Enjoy resort-style living at 1801 MetroWest. Our apartments for rent near me with pool offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent near me with pool. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like a sparkling pool, fitness center, and dog park, all designed to enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent Near Me with Pool",
      "seo_description": "Discover resort-style living at 1801 MetroWest. Our apartments for rent near me with pool feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fitness Center at 1801 MetroWest",
      "h2_subtitle": "Elevate your lifestyle at 1801 MetroWest. Our apartments for rent near me with fitness center offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent near me with fitness center. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like a state-of-the-art fitness center, sparkling pool, and dog park, all designed to enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Elevate your lifestyle at 1801 MetroWest. Our apartments for rent near me with fitness center feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-clubhouse-at-metrowest",
      "search_query": "Apartments For Rent Near Me with Clubhouse",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Clubhouse at 1801 MetroWest",
      "h2_subtitle": "Discover upscale living at 1801 MetroWest. Our apartments for rent near me with clubhouse offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent near me with clubhouse. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like a stylish clubhouse, sparkling pool, and state-of-the-art fitness center, all designed to enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent Near Me with Clubhouse",
      "seo_description": "Discover upscale living at 1801 MetroWest. Our apartments for rent near me with clubhouse feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-dog-park",
      "search_query": "Apartments For Rent Near Me with Dog Park",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Dog Park at 1801 MetroWest",
      "h2_subtitle": "Experience pet-friendly living at 1801 MetroWest. Our apartments for rent near me with dog park offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent near me with dog park. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like a dedicated dog park, sparkling pool, and state-of-the-art fitness center, all designed to enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent Near Me with Dog Park",
      "seo_description": "Experience pet-friendly living at 1801 MetroWest. Our apartments for rent near me with dog park feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-walk-up-1801-metrowest",
      "search_query": "Apartments For Rent Near Me with Walk-Up",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Walk-Up at 1801 MetroWest",
      "h2_subtitle": "Enjoy convenient living at 1801 MetroWest. Our apartments for rent near me with walk-up offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent near me with walk-up. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like convenient walk-up access, a sparkling pool, and a state-of-the-art fitness center, all designed to enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent Near Me with Walk-Up",
      "seo_description": "Enjoy convenient living at 1801 MetroWest. Our apartments for rent near me with walk-up feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-kitchen-metrowest",
      "search_query": "Apartments For Rent Near Me with Kitchen",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Kitchen at 1801 MetroWest",
      "h2_subtitle": "Experience culinary excellence at 1801 MetroWest. Our apartments for rent near me with kitchen offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent near me with kitchen. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like a modern kitchen, high-speed internet access, and a state-of-the-art fitness center, all designed to enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent Near Me with Kitchen",
      "seo_description": "Experience culinary excellence at 1801 MetroWest. Our apartments for rent near me with kitchen feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-storage-space",
      "search_query": "Apartments For Rent Near Me with Storage Space",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Storage Space at 1801 MetroWest",
      "h2_subtitle": "Maximize your living space at 1801 MetroWest. Our apartments for rent near me with storage space offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent near me with storage space. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like ample storage space, high-speed internet access, and a state-of-the-art fitness center, all designed to enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent Near Me with Storage Space",
      "seo_description": "Maximize your living space at 1801 MetroWest. Our apartments for rent near me with storage space feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-granite-countertops",
      "search_query": "Apartments For Rent Near Me with Granite Countertops",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Granite Countertops at 1801 MetroWest",
      "h2_subtitle": "Experience luxury living at 1801 MetroWest. Our apartments for rent near me with granite countertops offer upscale amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent near me with granite countertops. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like elegant granite countertops, high-speed internet access, and a state-of-the-art fitness center, all designed to enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent Near Me with Granite Countertops",
      "seo_description": "Experience luxury living at 1801 MetroWest. Our apartments for rent near me with granite countertops feature upscale amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-stainless-steel-appliances",
      "search_query": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Stainless Steel Appliances at 1801 MetroWest",
      "h2_subtitle": "Discover modern living at 1801 MetroWest. Our apartments for rent near me with stainless steel appliances offer upscale amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent near me with stainless steel appliances. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like high-speed internet access, elegant granite countertops, and a state-of-the-art fitness center, all designed to enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent Near Me with Stainless Steel Appliances",
      "seo_description": "Discover modern living at 1801 MetroWest. Our apartments for rent near me with stainless steel appliances feature upscale amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-hardwood-floors",
      "search_query": "Apartments For Rent Near Me with Hardwood Floors",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Hardwood Floors at 1801 MetroWest",
      "h2_subtitle": "Experience elegance at 1801 MetroWest. Our apartments for rent near me with hardwood floors offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent near me with hardwood floors. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like elegant hardwood floors, high-speed internet access, and a state-of-the-art fitness center, all designed to enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent Near Me with Hardwood Floors",
      "seo_description": "Experience elegance at 1801 MetroWest. Our apartments for rent near me with hardwood floors feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-orlando-near-adventhealth",
      "search_query": "Apartments For Rent In Orlando FL Near AdventHealth Orlando",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near AdventHealth Orlando at 1801 MetroWest",
      "h2_subtitle": "Discover convenient living at 1801 MetroWest. Our apartments for rent in Orlando FL near AdventHealth Orlando offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent in Orlando FL near AdventHealth Orlando. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like a concierge, business center, and state-of-the-art fitness center, all designed to enhance your living experience. Located conveniently near AdventHealth Orlando, you'll have access to exceptional and compassionate care with leading-edge treatments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent In Orlando FL Near AdventHealth Orlando",
      "seo_description": "Discover convenient living at 1801 MetroWest. Our apartments for rent in Orlando FL near AdventHealth Orlando feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-orlando-health-metrowest",
      "search_query": "Apartments For Rent In Orlando FL Near Orlando Health Dr. P. Phillips Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Orlando Health Dr. P. Phillips Hospital at 1801 MetroWest",
      "h2_subtitle": "Experience convenient living at 1801 MetroWest. Our apartments for rent in Orlando FL near Orlando Health Dr. P. Phillips Hospital offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent in Orlando FL near Orlando Health Dr. P. Phillips Hospital. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like a concierge, business center, and state-of-the-art fitness center, all designed to enhance your living experience. Located conveniently near Orlando Health Dr. P. Phillips Hospital, you'll have access to a full-service medical/surgical facility equipped with the latest technology in diagnostic imaging and cardiovascular care.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent In Orlando FL Near Orlando Health Dr. P. Phillips Hospital",
      "seo_description": "Experience convenient living at 1801 MetroWest. Our apartments for rent in Orlando FL near Orlando Health Dr. P. Phillips Hospital feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-orlando-fl-near-disney-university",
      "search_query": "Apartments For Rent In Orlando FL Near Disney University",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Disney University at 1801 MetroWest",
      "h2_subtitle": "Experience magical living at 1801 MetroWest. Our apartments for rent in Orlando FL near Disney University offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent in Orlando FL near Disney University. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like a concierge, business center, and state-of-the-art fitness center, all designed to enhance your living experience. Located conveniently near Disney University, you'll have easy access to educational opportunities and the magic of Disney.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent In Orlando FL Near Disney University",
      "seo_description": "Experience magical living at 1801 MetroWest. Our apartments for rent in Orlando FL near Disney University feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-orlando-fl-near-universal-tech",
      "search_query": "Apartments For Rent In Orlando FL Near Universal Technical Institute",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Universal Technical Institute at 1801 MetroWest",
      "h2_subtitle": "Discover convenient living at 1801 MetroWest. Our apartments for rent in Orlando FL near Universal Technical Institute offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent in Orlando FL near Universal Technical Institute. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like a concierge, business center, and state-of-the-art fitness center, all designed to enhance your living experience. Located conveniently near Universal Technical Institute, you'll have easy access to top-notch technical education and training.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent In Orlando FL Near Universal Technical Institute",
      "seo_description": "Discover convenient living at 1801 MetroWest. Our apartments for rent in Orlando FL near Universal Technical Institute feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-everest-university-north-orlando",
      "search_query": "Apartments For Rent In Orlando FL Near Everest University North Orlando",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Everest University North Orlando at 1801 MetroWest",
      "h2_subtitle": "Experience convenient living at 1801 MetroWest. Our apartments for rent in Orlando FL near Everest University North Orlando offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent in Orlando FL near Everest University North Orlando. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like a concierge, business center, and state-of-the-art fitness center, all designed to enhance your living experience. Located conveniently near Everest University North Orlando, you'll have easy access to quality education and training.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent In Orlando FL Near Everest University North Orlando",
      "seo_description": "Experience convenient living at 1801 MetroWest. Our apartments for rent in Orlando FL near Everest University North Orlando feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-valencia-college-east-campus",
      "search_query": "Apartments For Rent In Orlando FL Near Valencia College East Campus Library",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Valencia College East Campus Library at 1801 MetroWest",
      "h2_subtitle": "Discover convenient living at 1801 MetroWest. Our apartments for rent in Orlando FL near Valencia College East Campus Library offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent in Orlando FL near Valencia College East Campus Library. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like a concierge, business center, and state-of-the-art fitness center, all designed to enhance your living experience. Located conveniently near Valencia College East Campus Library, you'll have easy access to educational resources and a supportive learning environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent In Orlando FL Near Valencia College East Campus Library",
      "seo_description": "Discover convenient living at 1801 MetroWest. Our apartments for rent in Orlando FL near Valencia College East Campus Library feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-concorde-career-institute",
      "search_query": "Apartments For Rent In Orlando FL Near Concorde Career Institute - Orlando",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Concorde Career Institute - Orlando at 1801 MetroWest",
      "h2_subtitle": "Experience convenient living at 1801 MetroWest. Our apartments for rent in Orlando FL near Concorde Career Institute - Orlando offer luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent in Orlando FL near Concorde Career Institute - Orlando. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Enjoy community amenities like a concierge, business center, and state-of-the-art fitness center, all designed to enhance your living experience. Located conveniently near Concorde Career Institute - Orlando, you'll have easy access to quality career-focused education and training.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent In Orlando FL Near Concorde Career Institute - Orlando",
      "seo_description": "Experience convenient living at 1801 MetroWest. Our apartments for rent in Orlando FL near Concorde Career Institute - Orlando feature luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690533913559040",
      "source": "custom",
      "page_item_url": "apartments-for-rent-orlando-near-eagles-nest",
      "search_query": "Apartments For Rent In Orlando FL Near Eagle's Nest Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Eagle's Nest Elementary School at 1801 MetroWest",
      "h2_subtitle": "Ideal for families, 1801 MetroWest offers apartments for rent in Orlando FL near Eagle's Nest Elementary School. Enjoy luxurious amenities and spacious floor plans.",
      "page_copy": "Lined with palm trees and packed with amenities, 1801 MetroWest is your home for picture-perfect living. Update your routine and experience ceaseless comfort in our apartments for rent in Orlando FL near Eagle's Nest Elementary School, just 2.0 km away. Oversized floor plans and remarkable features set the scene for your best lifestyle. From the plank, wood-style flooring to the stainless-steel appliances in your upscale chef's kitchen, your new home is sure to feel like the right fit. Families will appreciate the close proximity to Eagle's Nest Elementary School, providing a safe and nurturing environment for their children. Enjoy community amenities like a concierge, business center, and state-of-the-art fitness center, all designed to enhance your living experience. Choose from our available one and two bedroom floor plans to find the perfect home for your family.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
      "featured_image_media": {
        "alt_text": "Metrowest Premier Apartments monument sign",
        "public_id": "019f6c0a-f240-73af-b9c8-ea3a19e15fa1",
        "storage_key": "property/5690533913559040/019f6c0a-f240-73af-b9c8-ea3a19e15fa1.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
      "blank_image_media": {
        "alt_text": "Exterior of apartment building with palm trees",
        "public_id": "019f6c0a-fe7b-7738-9f6f-fe4ea477248d",
        "storage_key": "property/5690533913559040/019f6c0a-fe7b-7738-9f6f-fe4ea477248d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "1801 MetroWest | Apartments For Rent In Orlando FL Near Eagle's Nest Elementary School",
      "seo_description": "Ideal for families, 1801 MetroWest offers apartments for rent in Orlando FL near Eagle's Nest Elementary School. Enjoy luxurious amenities and spacious floor plans for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2129"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470836"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a0f\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a0f\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4767207"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NRCXBW6"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://1801metrow.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443957572"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dgow3yozv2m"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/5cb123f6-cbc9-46df-b7e6-dcedaebfb7ce"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "407-934-0350"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImRlS01NUXhCaFJObVcyb1RpWUpLeEE9PSIsInZhbHVlIjoibjFWbFljYlgzOWMwdHpjNmF0VzVqdz09IiwibWFjIjoiYzdlNzc4NDdiYzIwZDZiNWY4MzQwZTkwOTY1MjdiYmNhMWNiNWQ4Zjc0M2FjNmQ4YTlkZjhhMzA4YmZlYTRjZiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2129",
  "custom_repli_id": "2376470836",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a0f\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a0f\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4767207",
  "custom_google_gtm_id": "GTM-NRCXBW6",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://1801metrow.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443957572",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/dgow3yozv2m",
  "custom_self_guided_tour_url": "https://selftournow.com/property/5cb123f6-cbc9-46df-b7e6-dcedaebfb7ce",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "407-934-0350",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImRlS01NUXhCaFJObVcyb1RpWUpLeEE9PSIsInZhbHVlIjoibjFWbFljYlgzOWMwdHpjNmF0VzVqdz09IiwibWFjIjoiYzdlNzc4NDdiYzIwZDZiNWY4MzQwZTkwOTY1MjdiYmNhMWNiNWQ4Zjc0M2FjNmQ4YTlkZjhhMzA4YmZlYTRjZiJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:41:27.914Z';
